/* tslint:disable */
/* eslint:disable */
import 'isomorphic-fetch';

export type ThenArg<T> = T extends Promise<infer U>
  ? U
  : T extends (...args: any[]) => Promise<infer U>
  ? U
  : T;

type QueryParameters = {
  [key: string]:
    | string
    | number
    | string[]
    | number[]
    | boolean
    | boolean[]
    | undefined;
};

export type Error = {
  status: number;

  name: string;

  description?: string;

  payload?: {};

  userinfo?: string;
};
export type Season = {
  _id: string;

  appSpace: string;

  name: string;

  dateFrom: string;

  dateTo: string;

  sport: string;
};
export type SportObject = {
  _id: string;

  appSpace: string;

  name: string;

  sport: string;

  street: string;

  number: string;

  owner: string;

  zip: string;

  city: string;

  country: string;

  sportGrounds?: Array<{
    _id: string;

    name: string;

    sportGroundType: string;

    additionalData?: {};
  }>;
};
export type SportGround = {
  _id: string;

  name: string;

  sportGroundType: string;

  additionalData?: {};
};
export type Team = {
  _id: string;

  appSpace: string;

  logo?: {
    media_url: string;

    public_url: string;
  };

  smarttags?: Array<{
    key: string | number;

    values: Array<{
      key: string | number;

      title?: string | null;
    }>;
  }>;

  name: string;

  displayName: string;

  gender?: string;

  sport_sector: string;

  athletes?: Array<{
    sportnetUser: {
      _id: string;

      name: string;
    };

    additionalData?: {};
  }>;
};
export type Competition = {
  _id: string;

  competitionGroupId: string;

  homepageSectionIdOrUniqId?: string;

  appSpace: string;

  name: string;

  season: {
    _id: string;

    appSpace: string;

    name: string;

    dateFrom: string;

    dateTo: string;

    sport: string;
  };

  sport: string;

  parts?: Array<{
    _id: string;

    name: string;

    rounds?: Array<{
      _id: string;

      name: string;

      dateFrom: string;

      dateTo: string;
    }>;

    rules?: {};

    settings?: {};

    signup?: boolean;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    matches_count?: number;

    dateFrom: string;

    dateTo: string;
  }>;

  signup?: boolean;

  publication?: {};

  smarttags?: {
    key: string | number;

    values: Array<{
      key: string | number;

      title?: string | null;
    }>;
  };

  smarttagsByAppSpace?: Array<{
    appSpace: string;

    smarttags: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };
  }>;

  teams?: Array<{
    _id: string;

    name: string;

    appSpace: string;
  }>;
};
export type Match = {
  _id: string;

  appSpace: string;

  smarttags?: {
    key: string | number;

    values: Array<{
      key: string | number;

      title?: string | null;
    }>;
  };

  smarttagsByAppSpace?: Array<{
    appSpace: string;

    smarttags: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };
  }>;

  teams: Array<{
    _id: string;

    appSpace: string;

    logo?: {
      media_url: string;

      public_url: string;
    };

    smarttags?: Array<{
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    }>;

    name: string;

    displayName: string;

    gender?: string;

    sport_sector: string;

    athletes?: Array<{
      sportnetUser: {
        _id: string;

        name: string;
      };

      additionalData?: {};
    }>;
  }>;

  startDate: string;

  sportGround: {
    _id: string;

    name: string;

    sportGroundType: string;

    additionalData?: {};
  };

  competition: {
    _id: string;

    name: string;

    competitionGroupId: string;
  };

  competitionPart: {
    _id: string;

    name: string;
  };

  season: {
    _id: string;

    appSpace: string;

    name: string;

    dateFrom: string;

    dateTo: string;

    sport: string;
  };

  round?: {
    _id?: string;

    name: string;

    dateFrom?: string;

    dateTo?: string;
  };

  nominations: Array<{
    teamId?: string;

    athletes: Array<{
      sportnetUser: {
        _id: string;

        name: string;
      };

      additionalData?: {};
    }>;

    crew?: Array<{
      sportnetUser: {
        _id: string | null;

        name: string | null;
      };

      position: string;
    }>;

    closed?: boolean;
  }>;

  protocol?: {
    events?: Array<{}>;
  };

  rules?: {
    gender?: string;

    sport_sector?: string;

    discipline?: string;
  };

  closed?: boolean;

  contumation?: {
    isContumated: boolean;

    advantage: null | string;

    keepScore: boolean;
  };

  score?: Array<number>;

  livestream?: string;

  ticketsUrl?: string;

  resultsTable?: {
    results: Array<{
      team: {
        _id: string;

        name: string;

        displayName: string;

        resignation?: boolean;
      };

      stats: {
        matches: {
          played: number;

          won: number;

          draw: number;

          lost: number;
        };

        goals: {
          given: number;

          received: number;
        };

        points: number;
      };

      homeStats?: {
        matches: {
          played: number;

          won: number;

          draw: number;

          lost: number;
        };

        goals: {
          given: number;

          received: number;
        };

        points: number;
      };

      awayStats?: {
        matches: {
          played: number;

          won: number;

          draw: number;

          lost: number;
        };

        goals: {
          given: number;

          received: number;
        };

        points: number;
      };

      matches?: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;
        };

        result: 'W' | 'L' | 'D';

        homeaway: 'home' | 'away';

        matchId: string;

        score: string;
      }>;

      homeMatches?: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;
        };

        result: 'W' | 'L' | 'D';

        homeaway: 'home' | 'away';

        matchId: string;

        score: string;
      }>;

      awayMatches?: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;
        };

        result: 'W' | 'L' | 'D';

        homeaway: 'home' | 'away';

        matchId: string;

        score: string;
      }>;
    }>;

    players?: Array<{
      _id: string;

      teamId: string;

      name: string;

      stats: {
        match_starts?: number;

        match_appearances?: number;

        goals?: number;

        assists?: number;

        yellow_cards?: number;

        red_cards?: number;

        substitutions?: number;

        own_goals?: number;
      };
    }>;
  };

  settings: {
    players: {
      field: {
        min: number;

        max: number;
      };

      substitutes: {
        max: number;
      };
    };

    contumation: {
      score: number;
    };

    reverseTime: boolean;

    overlapTime: boolean;

    phases: {};
  };

  liveState?: {
    phase: string;

    seconds: number;

    ongoing: boolean;

    toggleDate: string;
  };

  drawId?: number;

  timer?: {};

  managers?: Array<{
    user: {
      _id: string;

      name: string;
    };

    type: {
      label: string;

      value: string;
    };

    grant?: boolean;
  }>;
};
export type Settings_Base_domain = string;
export type Settings = {
  domain?: string;

  homepageSectionIdOrUniqId?: string;
};
export type Settings_Edit = {
  domain?: string;

  homepageSectionIdOrUniqId?: string;
};
export type Pager = {
  limit: number;

  offset: number;

  total: number;

  nextOffset?: number;
};

class ApiError {
  public message: string;
  public details: Error | null = null;

  constructor(message: string) {
    this.message = message;
  }
}

/**
 *
 * @class Api
 * @param {(string)} [domainOrOptions] - The project domain.
 */
class Api {
  protected baseUrl: string = '';
  protected token: string = '';

  serializeQueryParams(parameters: QueryParameters) {
    return Object.keys(parameters)
      .reduce((acc: string[], p) => {
        const param = parameters[p];
        if (typeof param === 'undefined' || param === '') {
          return acc;
        }
        return [
          ...acc,
          `${encodeURIComponent(p)}=${encodeURIComponent(
            String(parameters[p]),
          )}`,
        ];
      }, [])
      .join('&');
  }

  protected transformParameter(value: any, transformOperation?: string) {
    switch (transformOperation) {
      case 'joinUsingPipes':
        return Array.isArray(value) ? value.join('|') : value;
      default:
        return value;
    }
  }

  public setBaseUrl(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  public setToken(token: string) {
    this.token = token;
  }

  protected appendAuthHeaders(headerParams: Headers) {
    const headers = new Headers(headerParams);
    if (this.token) {
      headers.append('Authorization', `Bearer ${this.token}`);
    }
    return headers;
  }

  private async request(
    method: string,
    url: string,
    body: any,
    headers: Headers = new Headers(),
    queryParameters: QueryParameters = {},
  ) {
    const queryParams =
      queryParameters && Object.keys(queryParameters).length
        ? this.serializeQueryParams(queryParameters)
        : null;
    const urlWithParams = url + (queryParams ? '?' + queryParams : '');

    if (headers.get('Content-Type') === 'multipart/form-data') {
      const form = new FormData();
      for (let k in body) {
        form.append(k, body[k]);
      }
      body = form;
    } else if (
      headers.get('Content-Type') === 'application/json' &&
      body &&
      Object.keys(body).length > 0
    ) {
      body = JSON.stringify(body);
    } else {
      body = undefined;
    }

    if (headers.get('Content-Type') === 'multipart/form-data') {
      headers.delete('Content-Type');
    }

    const response = await fetch(urlWithParams, { method, headers, body });
    if (response.ok) {
      const responseContentType =
        (response.headers && response.headers.get('Content-Type')) || '';
      if (responseContentType.includes('application/json')) {
        return response.json();
      } else if (responseContentType.includes('application/pdf')) {
        return response.blob();
      } else if (responseContentType.includes('text/plain')) {
        return response.text();
      }
      return {};
    } else {
      const err = new ApiError(response.statusText);
      err.details = await response.json();
      throw err;
    }
  }

  /**
   *
   * @method
   * @name Api#adminGetSeasons
   */
  adminGetSeasons(
    appSpace: string,
    parameters: {} = {},
  ): Promise<{
    seasons: Array<{
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    }>;
  }> {
    let path = '/admin/{appSpace}/seasons';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminCreateSeason
   */
  adminCreateSeason(
    appSpace: string,
    parameters: {} = {},
    body: {
      _id?: string;

      appSpace?: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    name: string;

    dateFrom: string;

    dateTo: string;

    sport: string;
  }> {
    let path = '/admin/{appSpace}/seasons';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetSeason
   */
  adminGetSeason(
    appSpace: string,
    seasonId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    appSpace: string;

    name: string;

    dateFrom: string;

    dateTo: string;

    sport: string;
  }> {
    let path = '/admin/{appSpace}/seasons/{seasonId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{seasonId}', seasonId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminUpdateSeason
   */
  adminUpdateSeason(
    appSpace: string,
    seasonId: string,
    parameters: {} = {},
    body: {
      _id?: string;

      appSpace?: string;

      name?: string;

      dateFrom?: string;

      dateTo?: string;

      sport?: string;
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    name: string;

    dateFrom: string;

    dateTo: string;

    sport: string;
  }> {
    let path = '/admin/{appSpace}/seasons/{seasonId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{seasonId}', seasonId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminDeleteSeason
   */
  adminDeleteSeason(
    appSpace: string,
    seasonId: string,
    parameters: {} = {},
  ): Promise<{}> {
    let path = '/admin/{appSpace}/seasons/{seasonId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{seasonId}', seasonId.toString());

    return this.request(
      'DELETE',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetSuitableSeasons
   */
  adminGetSuitableSeasons(
    appSpace: string,
    parameters: {} = {},
  ): Promise<{
    seasons: Array<{
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    }>;
  }> {
    let path = '/admin/{appSpace}/suitable-seasons';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetSportObjects
   */
  adminGetSportObjects(
    appSpace: string,
    parameters: {} = {},
  ): Promise<{
    sportobjects: Array<{
      _id: string;

      appSpace: string;

      name: string;

      sport: string;

      street: string;

      number: string;

      owner: string;

      zip: string;

      city: string;

      country: string;

      sportGrounds?: Array<{
        _id: string;

        name: string;

        sportGroundType: string;

        additionalData?: {};
      }>;
    }>;
  }> {
    let path = '/admin/{appSpace}/sport-objects';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminCreateSportObject
   */
  adminCreateSportObject(
    appSpace: string,
    parameters: {} = {},
    body: {
      name: string;

      owner: string;

      sport: string;

      street: string;

      number: string;

      zip: string;

      city: string;

      country: string;
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    name: string;

    sport: string;

    street: string;

    number: string;

    owner: string;

    zip: string;

    city: string;

    country: string;

    sportGrounds?: Array<{
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    }>;
  }> {
    let path = '/admin/{appSpace}/sport-objects';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetSportObject
   */
  adminGetSportObject(
    appSpace: string,
    sportobjectId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    appSpace: string;

    name: string;

    sport: string;

    street: string;

    number: string;

    owner: string;

    zip: string;

    city: string;

    country: string;

    sportGrounds?: Array<{
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    }>;
  }> {
    let path = '/admin/{appSpace}/sport-objects/{sportobjectId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{sportobjectId}', sportobjectId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminUpdateSportObject
   */
  adminUpdateSportObject(
    appSpace: string,
    sportobjectId: string,
    parameters: {} = {},
    body: {
      name?: string;

      owner?: string;

      street?: string;

      number?: string;

      zip?: string;

      city?: string;

      country?: string;
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    name: string;

    sport: string;

    street: string;

    number: string;

    owner: string;

    zip: string;

    city: string;

    country: string;

    sportGrounds?: Array<{
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    }>;
  }> {
    let path = '/admin/{appSpace}/sport-objects/{sportobjectId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{sportobjectId}', sportobjectId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminDeleteSportObject
   */
  adminDeleteSportObject(
    appSpace: string,
    sportobjectId: string,
    parameters: {} = {},
  ): Promise<{}> {
    let path = '/admin/{appSpace}/sport-objects/{sportobjectId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{sportobjectId}', sportobjectId.toString());

    return this.request(
      'DELETE',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminCreateSportGround
   */
  adminCreateSportGround(
    appSpace: string,
    sportobjectId: string,
    parameters: {} = {},
    body: {
      name?: string;

      sportGroundType?: string;

      additionalData?: {};
    },
  ): Promise<{
    _id: string;

    name: string;

    sportGroundType: string;

    additionalData?: {};
  }> {
    let path = '/admin/{appSpace}/sport-objects/{sportobjectId}/sportGrounds';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{sportobjectId}', sportobjectId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetSportGround
   */
  adminGetSportGround(
    appSpace: string,
    sportobjectId: string,
    sportGroundId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    name: string;

    sportGroundType: string;

    additionalData?: {};
  }> {
    let path =
      '/admin/{appSpace}/sport-objects/{sportobjectId}/sportGrounds/{sportGroundId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{sportobjectId}', sportobjectId.toString());

    path = path.replace('{sportGroundId}', sportGroundId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminUpdateSportGround
   */
  adminUpdateSportGround(
    appSpace: string,
    sportobjectId: string,
    sportGroundId: string,
    parameters: {} = {},
    body: {
      name?: string;

      sportGroundType?: string;

      additionalData?: {};
    },
  ): Promise<{
    _id: string;

    name: string;

    sportGroundType: string;

    additionalData?: {};
  }> {
    let path =
      '/admin/{appSpace}/sport-objects/{sportobjectId}/sportGrounds/{sportGroundId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{sportobjectId}', sportobjectId.toString());

    path = path.replace('{sportGroundId}', sportGroundId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetAllSportGrounds
   */
  adminGetAllSportGrounds(
    appSpace: string,
    parameters: {} = {},
  ): Promise<{
    items: Array<{
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    }>;
  }> {
    let path = '/admin/{appSpace}/all-sportgrounds';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetTeams
   */
  adminGetTeams(
    appSpace: string,
    parameters: {
      limit?: number;
      offset?: number;
      seasonIds?: Array<string>;
    } = {},
  ): Promise<{
    limit: number;

    offset: number;

    total: number;

    nextOffset?: number;

    teams: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;
  }> {
    let path = '/admin/{appSpace}/teams';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    queryParameters['limit'] = 100;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    if (typeof parameters['seasonIds'] !== 'undefined') {
      queryParameters['season_ids'] = parameters['seasonIds'];
    }

    queryParameters['season_ids'] = this.transformParameter(
      queryParameters['season_ids'],
    );

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminCreateTeam
   */
  adminCreateTeam(
    appSpace: string,
    parameters: {} = {},
    body: {
      _id?: string;

      appSpace?: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    logo?: {
      media_url: string;

      public_url: string;
    };

    smarttags?: Array<{
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    }>;

    name: string;

    displayName: string;

    gender?: string;

    sport_sector: string;

    athletes?: Array<{
      sportnetUser: {
        _id: string;

        name: string;
      };

      additionalData?: {};
    }>;
  }> {
    let path = '/admin/{appSpace}/teams';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetTeam
   */
  adminGetTeam(
    appSpace: string,
    teamId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    appSpace: string;

    logo?: {
      media_url: string;

      public_url: string;
    };

    smarttags?: Array<{
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    }>;

    name: string;

    displayName: string;

    gender?: string;

    sport_sector: string;

    athletes?: Array<{
      sportnetUser: {
        _id: string;

        name: string;
      };

      additionalData?: {};
    }>;
  }> {
    let path = '/admin/{appSpace}/teams/{teamId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminUpdateTeam
   */
  adminUpdateTeam(
    appSpace: string,
    teamId: string,
    parameters: {} = {},
    body: {
      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name?: string;

      displayName?: string;

      logo?: {
        media_url: string;

        public_url: string;
      };
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    logo?: {
      media_url: string;

      public_url: string;
    };

    smarttags?: Array<{
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    }>;

    name: string;

    displayName: string;

    gender?: string;

    sport_sector: string;

    athletes?: Array<{
      sportnetUser: {
        _id: string;

        name: string;
      };

      additionalData?: {};
    }>;
  }> {
    let path = '/admin/{appSpace}/teams/{teamId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminDeleteTeam
   */
  adminDeleteTeam(
    appSpace: string,
    teamId: string,
    parameters: {} = {},
  ): Promise<{}> {
    let path = '/admin/{appSpace}/teams/{teamId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'DELETE',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetTeamCompetitions
   */
  adminGetTeamCompetitions(
    appSpace: string,
    teamId: string,
    parameters: {} = {},
  ): Promise<{
    competitions: Array<{
      _id: string;

      competitionGroupId: string;

      homepageSectionIdOrUniqId?: string;

      appSpace: string;

      name: string;

      season: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      sport: string;

      parts?: Array<{
        _id: string;

        name: string;

        rounds?: Array<{
          _id: string;

          name: string;

          dateFrom: string;

          dateTo: string;
        }>;

        rules?: {};

        settings?: {};

        signup?: boolean;

        resultsTable?: {
          results: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;

              resignation?: boolean;
            };

            stats: {
              matches: {
                played: number;

                won: number;

                draw: number;

                lost: number;
              };

              goals: {
                given: number;

                received: number;
              };

              points: number;
            };

            homeStats?: {
              matches: {
                played: number;

                won: number;

                draw: number;

                lost: number;
              };

              goals: {
                given: number;

                received: number;
              };

              points: number;
            };

            awayStats?: {
              matches: {
                played: number;

                won: number;

                draw: number;

                lost: number;
              };

              goals: {
                given: number;

                received: number;
              };

              points: number;
            };

            matches?: Array<{
              team: {
                _id: string;

                name: string;

                displayName: string;
              };

              result: 'W' | 'L' | 'D';

              homeaway: 'home' | 'away';

              matchId: string;

              score: string;
            }>;

            homeMatches?: Array<{
              team: {
                _id: string;

                name: string;

                displayName: string;
              };

              result: 'W' | 'L' | 'D';

              homeaway: 'home' | 'away';

              matchId: string;

              score: string;
            }>;

            awayMatches?: Array<{
              team: {
                _id: string;

                name: string;

                displayName: string;
              };

              result: 'W' | 'L' | 'D';

              homeaway: 'home' | 'away';

              matchId: string;

              score: string;
            }>;
          }>;

          players?: Array<{
            _id: string;

            teamId: string;

            name: string;

            stats: {
              match_starts?: number;

              match_appearances?: number;

              goals?: number;

              assists?: number;

              yellow_cards?: number;

              red_cards?: number;

              substitutions?: number;

              own_goals?: number;
            };
          }>;
        };

        matches_count?: number;

        dateFrom: string;

        dateTo: string;
      }>;

      signup?: boolean;

      publication?: {};

      smarttags?: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };

      smarttagsByAppSpace?: Array<{
        appSpace: string;

        smarttags: {
          key: string | number;

          values: Array<{
            key: string | number;

            title?: string | null;
          }>;
        };
      }>;

      teams?: Array<{
        _id: string;

        name: string;

        appSpace: string;
      }>;
    }>;
  }> {
    let path = '/admin/{appSpace}/teams/{teamId}/competitions';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetCompetitions
   */
  adminGetCompetitions(
    appSpace: string,
    parameters: {
      limit?: number;
      offset?: number;
      seasonIds?: Array<string>;
      q?: string;
    } = {},
  ): Promise<{
    limit: number;

    offset: number;

    total: number;

    nextOffset?: number;

    competitions: Array<{
      _id: string;

      competitionGroupId: string;

      homepageSectionIdOrUniqId?: string;

      appSpace: string;

      name: string;

      season: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      sport: string;

      parts?: Array<{
        _id: string;

        name: string;

        rounds?: Array<{
          _id: string;

          name: string;

          dateFrom: string;

          dateTo: string;
        }>;

        rules?: {};

        settings?: {};

        signup?: boolean;

        resultsTable?: {
          results: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;

              resignation?: boolean;
            };

            stats: {
              matches: {
                played: number;

                won: number;

                draw: number;

                lost: number;
              };

              goals: {
                given: number;

                received: number;
              };

              points: number;
            };

            homeStats?: {
              matches: {
                played: number;

                won: number;

                draw: number;

                lost: number;
              };

              goals: {
                given: number;

                received: number;
              };

              points: number;
            };

            awayStats?: {
              matches: {
                played: number;

                won: number;

                draw: number;

                lost: number;
              };

              goals: {
                given: number;

                received: number;
              };

              points: number;
            };

            matches?: Array<{
              team: {
                _id: string;

                name: string;

                displayName: string;
              };

              result: 'W' | 'L' | 'D';

              homeaway: 'home' | 'away';

              matchId: string;

              score: string;
            }>;

            homeMatches?: Array<{
              team: {
                _id: string;

                name: string;

                displayName: string;
              };

              result: 'W' | 'L' | 'D';

              homeaway: 'home' | 'away';

              matchId: string;

              score: string;
            }>;

            awayMatches?: Array<{
              team: {
                _id: string;

                name: string;

                displayName: string;
              };

              result: 'W' | 'L' | 'D';

              homeaway: 'home' | 'away';

              matchId: string;

              score: string;
            }>;
          }>;

          players?: Array<{
            _id: string;

            teamId: string;

            name: string;

            stats: {
              match_starts?: number;

              match_appearances?: number;

              goals?: number;

              assists?: number;

              yellow_cards?: number;

              red_cards?: number;

              substitutions?: number;

              own_goals?: number;
            };
          }>;
        };

        matches_count?: number;

        dateFrom: string;

        dateTo: string;
      }>;

      signup?: boolean;

      publication?: {};

      smarttags?: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };

      smarttagsByAppSpace?: Array<{
        appSpace: string;

        smarttags: {
          key: string | number;

          values: Array<{
            key: string | number;

            title?: string | null;
          }>;
        };
      }>;

      teams?: Array<{
        _id: string;

        name: string;

        appSpace: string;
      }>;
    }>;
  }> {
    let path = '/admin/{appSpace}/competitions';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    queryParameters['limit'] = 100;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    if (typeof parameters['seasonIds'] !== 'undefined') {
      queryParameters['season_ids'] = parameters['seasonIds'];
    }

    queryParameters['season_ids'] = this.transformParameter(
      queryParameters['season_ids'],
    );

    if (typeof parameters['q'] !== 'undefined') {
      queryParameters['q'] = parameters['q'];
    }

    queryParameters['q'] = this.transformParameter(queryParameters['q']);

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminCreateCompetition
   */
  adminCreateCompetition(
    appSpace: string,
    parameters: {} = {},
    body: {
      competitionGroupId?: string;

      homepageSectionIdOrUniqId?: string;

      name: string;

      season: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      sport: string;

      signup?: boolean;

      publication?: {};

      smarttags?: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };

      smarttagsByAppSpace?: Array<{
        appSpace: string;

        smarttags: {
          key: string | number;

          values: Array<{
            key: string | number;

            title?: string | null;
          }>;
        };
      }>;

      teams?: Array<{
        _id: string;

        name: string;

        appSpace: string;
      }>;
    },
  ): Promise<{
    _id: string;

    competitionGroupId: string;

    homepageSectionIdOrUniqId?: string;

    appSpace: string;

    name: string;

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    sport: string;

    parts?: Array<{
      _id: string;

      name: string;

      rounds?: Array<{
        _id: string;

        name: string;

        dateFrom: string;

        dateTo: string;
      }>;

      rules?: {};

      settings?: {};

      signup?: boolean;

      resultsTable?: {
        results: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;

            resignation?: boolean;
          };

          stats: {
            matches: {
              played: number;

              won: number;

              draw: number;

              lost: number;
            };

            goals: {
              given: number;

              received: number;
            };

            points: number;
          };

          homeStats?: {
            matches: {
              played: number;

              won: number;

              draw: number;

              lost: number;
            };

            goals: {
              given: number;

              received: number;
            };

            points: number;
          };

          awayStats?: {
            matches: {
              played: number;

              won: number;

              draw: number;

              lost: number;
            };

            goals: {
              given: number;

              received: number;
            };

            points: number;
          };

          matches?: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;
            };

            result: 'W' | 'L' | 'D';

            homeaway: 'home' | 'away';

            matchId: string;

            score: string;
          }>;

          homeMatches?: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;
            };

            result: 'W' | 'L' | 'D';

            homeaway: 'home' | 'away';

            matchId: string;

            score: string;
          }>;

          awayMatches?: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;
            };

            result: 'W' | 'L' | 'D';

            homeaway: 'home' | 'away';

            matchId: string;

            score: string;
          }>;
        }>;

        players?: Array<{
          _id: string;

          teamId: string;

          name: string;

          stats: {
            match_starts?: number;

            match_appearances?: number;

            goals?: number;

            assists?: number;

            yellow_cards?: number;

            red_cards?: number;

            substitutions?: number;

            own_goals?: number;
          };
        }>;
      };

      matches_count?: number;

      dateFrom: string;

      dateTo: string;
    }>;

    signup?: boolean;

    publication?: {};

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams?: Array<{
      _id: string;

      name: string;

      appSpace: string;
    }>;
  }> {
    let path = '/admin/{appSpace}/competitions';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetCompetitionsByCompetitionGroup
   */
  adminGetCompetitionsByCompetitionGroup(
    appSpace: string,
    parameters: {
      limit?: number;
      offset?: number;
    } = {},
  ): Promise<{
    limit: number;

    offset: number;

    total: number;

    nextOffset?: number;

    competitions: Array<{
      _id: string;

      competitionGroupId: string;

      homepageSectionIdOrUniqId?: string;

      appSpace: string;

      name: string;

      season: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      sport: string;

      parts?: Array<{
        _id: string;

        name: string;

        rounds?: Array<{
          _id: string;

          name: string;

          dateFrom: string;

          dateTo: string;
        }>;

        rules?: {};

        settings?: {};

        signup?: boolean;

        resultsTable?: {
          results: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;

              resignation?: boolean;
            };

            stats: {
              matches: {
                played: number;

                won: number;

                draw: number;

                lost: number;
              };

              goals: {
                given: number;

                received: number;
              };

              points: number;
            };

            homeStats?: {
              matches: {
                played: number;

                won: number;

                draw: number;

                lost: number;
              };

              goals: {
                given: number;

                received: number;
              };

              points: number;
            };

            awayStats?: {
              matches: {
                played: number;

                won: number;

                draw: number;

                lost: number;
              };

              goals: {
                given: number;

                received: number;
              };

              points: number;
            };

            matches?: Array<{
              team: {
                _id: string;

                name: string;

                displayName: string;
              };

              result: 'W' | 'L' | 'D';

              homeaway: 'home' | 'away';

              matchId: string;

              score: string;
            }>;

            homeMatches?: Array<{
              team: {
                _id: string;

                name: string;

                displayName: string;
              };

              result: 'W' | 'L' | 'D';

              homeaway: 'home' | 'away';

              matchId: string;

              score: string;
            }>;

            awayMatches?: Array<{
              team: {
                _id: string;

                name: string;

                displayName: string;
              };

              result: 'W' | 'L' | 'D';

              homeaway: 'home' | 'away';

              matchId: string;

              score: string;
            }>;
          }>;

          players?: Array<{
            _id: string;

            teamId: string;

            name: string;

            stats: {
              match_starts?: number;

              match_appearances?: number;

              goals?: number;

              assists?: number;

              yellow_cards?: number;

              red_cards?: number;

              substitutions?: number;

              own_goals?: number;
            };
          }>;
        };

        matches_count?: number;

        dateFrom: string;

        dateTo: string;
      }>;

      signup?: boolean;

      publication?: {};

      smarttags?: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };

      smarttagsByAppSpace?: Array<{
        appSpace: string;

        smarttags: {
          key: string | number;

          values: Array<{
            key: string | number;

            title?: string | null;
          }>;
        };
      }>;

      teams?: Array<{
        _id: string;

        name: string;

        appSpace: string;
      }>;
    }>;
  }> {
    let path = '/admin/{appSpace}/competitions-by-group';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    queryParameters['limit'] = 100;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetCompetition
   */
  adminGetCompetition(
    appSpace: string,
    competitionId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    competitionGroupId: string;

    homepageSectionIdOrUniqId?: string;

    appSpace: string;

    name: string;

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    sport: string;

    parts?: Array<{
      _id: string;

      name: string;

      rounds?: Array<{
        _id: string;

        name: string;

        dateFrom: string;

        dateTo: string;
      }>;

      rules?: {};

      settings?: {};

      signup?: boolean;

      resultsTable?: {
        results: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;

            resignation?: boolean;
          };

          stats: {
            matches: {
              played: number;

              won: number;

              draw: number;

              lost: number;
            };

            goals: {
              given: number;

              received: number;
            };

            points: number;
          };

          homeStats?: {
            matches: {
              played: number;

              won: number;

              draw: number;

              lost: number;
            };

            goals: {
              given: number;

              received: number;
            };

            points: number;
          };

          awayStats?: {
            matches: {
              played: number;

              won: number;

              draw: number;

              lost: number;
            };

            goals: {
              given: number;

              received: number;
            };

            points: number;
          };

          matches?: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;
            };

            result: 'W' | 'L' | 'D';

            homeaway: 'home' | 'away';

            matchId: string;

            score: string;
          }>;

          homeMatches?: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;
            };

            result: 'W' | 'L' | 'D';

            homeaway: 'home' | 'away';

            matchId: string;

            score: string;
          }>;

          awayMatches?: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;
            };

            result: 'W' | 'L' | 'D';

            homeaway: 'home' | 'away';

            matchId: string;

            score: string;
          }>;
        }>;

        players?: Array<{
          _id: string;

          teamId: string;

          name: string;

          stats: {
            match_starts?: number;

            match_appearances?: number;

            goals?: number;

            assists?: number;

            yellow_cards?: number;

            red_cards?: number;

            substitutions?: number;

            own_goals?: number;
          };
        }>;
      };

      matches_count?: number;

      dateFrom: string;

      dateTo: string;
    }>;

    signup?: boolean;

    publication?: {};

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams?: Array<{
      _id: string;

      name: string;

      appSpace: string;
    }>;
  }> {
    let path = '/admin/{appSpace}/competitions/{competitionId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminUpdateCompetition
   */
  adminUpdateCompetition(
    appSpace: string,
    competitionId: string,
    parameters: {} = {},
    body: {
      name?: string;

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      season?: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      homepageSectionIdOrUniqId?: string;

      sport?: string;

      signup?: boolean;

      publication?: {
        logo?: {
          filepath?: string;

          media_url?: string;

          public_url?: string;
        };

        published?: boolean;
      };
    },
  ): Promise<{
    _id: string;

    competitionGroupId: string;

    homepageSectionIdOrUniqId?: string;

    appSpace: string;

    name: string;

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    sport: string;

    parts?: Array<{
      _id: string;

      name: string;

      rounds?: Array<{
        _id: string;

        name: string;

        dateFrom: string;

        dateTo: string;
      }>;

      rules?: {};

      settings?: {};

      signup?: boolean;

      resultsTable?: {
        results: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;

            resignation?: boolean;
          };

          stats: {
            matches: {
              played: number;

              won: number;

              draw: number;

              lost: number;
            };

            goals: {
              given: number;

              received: number;
            };

            points: number;
          };

          homeStats?: {
            matches: {
              played: number;

              won: number;

              draw: number;

              lost: number;
            };

            goals: {
              given: number;

              received: number;
            };

            points: number;
          };

          awayStats?: {
            matches: {
              played: number;

              won: number;

              draw: number;

              lost: number;
            };

            goals: {
              given: number;

              received: number;
            };

            points: number;
          };

          matches?: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;
            };

            result: 'W' | 'L' | 'D';

            homeaway: 'home' | 'away';

            matchId: string;

            score: string;
          }>;

          homeMatches?: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;
            };

            result: 'W' | 'L' | 'D';

            homeaway: 'home' | 'away';

            matchId: string;

            score: string;
          }>;

          awayMatches?: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;
            };

            result: 'W' | 'L' | 'D';

            homeaway: 'home' | 'away';

            matchId: string;

            score: string;
          }>;
        }>;

        players?: Array<{
          _id: string;

          teamId: string;

          name: string;

          stats: {
            match_starts?: number;

            match_appearances?: number;

            goals?: number;

            assists?: number;

            yellow_cards?: number;

            red_cards?: number;

            substitutions?: number;

            own_goals?: number;
          };
        }>;
      };

      matches_count?: number;

      dateFrom: string;

      dateTo: string;
    }>;

    signup?: boolean;

    publication?: {};

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams?: Array<{
      _id: string;

      name: string;

      appSpace: string;
    }>;
  }> {
    let path = '/admin/{appSpace}/competitions/{competitionId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminDeleteCompetition
   */
  adminDeleteCompetition(
    appSpace: string,
    competitionId: string,
    parameters: {} = {},
  ): Promise<{}> {
    let path = '/admin/{appSpace}/competitions/{competitionId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    return this.request(
      'DELETE',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#regenerateAllResults
   */
  regenerateAllResults(parameters: {} = {}): Promise<{}> {
    let path = '/app/regenerate';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#appDeleteCompetition
   */
  appDeleteCompetition(
    competitionId: string,
    parameters: {} = {},
  ): Promise<{}> {
    let path = '/app/competitions/{competitionId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    return this.request(
      'DELETE',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetCompetitionSuitableTeams
   */
  adminGetCompetitionSuitableTeams(
    appSpace: string,
    competitionId: string,
    parameters: {
      limit?: number;
      offset?: number;
    } = {},
  ): Promise<{
    items?: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;
  }> {
    let path = '/admin/{appSpace}/competitions/{competitionId}/suitable-teams';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    queryParameters['limit'] = 100;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetCompetitionPartTeamSquad
   */
  adminGetCompetitionPartTeamSquad(
    appSpace: string,
    competitionId: string,
    partId: string,
    teamId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    name: string;

    type?: string;

    sport_sector: string;

    squad?: {
      athletes?: Array<{
        additionalProperties?: {};

        sportnetUser: {
          _id: string;

          name: string;
        };
      }>;
    };
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/teams/{teamId}/players';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminAddPlayerToCompetitionPartTeamSquad
   */
  adminAddPlayerToCompetitionPartTeamSquad(
    appSpace: string,
    competitionId: string,
    partId: string,
    teamId: string,
    parameters: {} = {},
    body: {
      sportnetId?: string;

      citizenship?: string | null;

      additionalData?: {};
    },
  ): Promise<{
    _id?: string;

    name?: string;

    squad?: Array<{}>;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/teams/{teamId}/players';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminAddPlayersToCompetitionPartTeamSquad
   */
  adminAddPlayersToCompetitionPartTeamSquad(
    appSpace: string,
    competitionId: string,
    partId: string,
    teamId: string,
    parameters: {} = {},
    body: {
      players: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    },
  ): Promise<{
    _id?: string;

    name?: string;

    squad?: Array<{}>;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/teams/{teamId}/players';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminEditPlayerInCompetitionPartTeamSquad
   */
  adminEditPlayerInCompetitionPartTeamSquad(
    appSpace: string,
    competitionId: string,
    partId: string,
    teamId: string,
    sportnetId: string,
    parameters: {} = {},
    body: {
      additionalData?: {};
    },
  ): Promise<{
    _id?: string;

    name?: string;

    squad?: Array<{}>;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/teams/{teamId}/players/{sportnetId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    path = path.replace('{sportnetId}', sportnetId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminRemovePlayerFromCompetitionPartTeamSquad
   */
  adminRemovePlayerFromCompetitionPartTeamSquad(
    appSpace: string,
    competitionId: string,
    partId: string,
    teamId: string,
    sportnetId: string,
    parameters: {} = {},
  ): Promise<{
    _id?: string;

    name?: string;

    squad?: Array<{}>;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/teams/{teamId}/players/{sportnetId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    path = path.replace('{sportnetId}', sportnetId.toString());

    return this.request(
      'DELETE',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminAddCrewMemberToCompetitionPartTeamSquad
   */
  adminAddCrewMemberToCompetitionPartTeamSquad(
    appSpace: string,
    competitionId: string,
    partId: string,
    teamId: string,
    parameters: {} = {},
    body: {
      sportnetId?: string;

      position?: string;
    },
  ): Promise<{
    _id?: string;

    name?: string;

    squad?: Array<{}>;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/teams/{teamId}/crew';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminEditCrewMemberInCompetitionPartTeamSquad
   */
  adminEditCrewMemberInCompetitionPartTeamSquad(
    appSpace: string,
    competitionId: string,
    partId: string,
    teamId: string,
    sportnetId: string,
    parameters: {} = {},
    body: {
      position?: string;
    },
  ): Promise<{
    _id?: string;

    name?: string;

    squad?: Array<{}>;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/teams/{teamId}/crew/{sportnetId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    path = path.replace('{sportnetId}', sportnetId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminRemoveCrewMemberFromCompetitionPartTeamSquad
   */
  adminRemoveCrewMemberFromCompetitionPartTeamSquad(
    appSpace: string,
    competitionId: string,
    partId: string,
    teamId: string,
    sportnetId: string,
    parameters: {} = {},
  ): Promise<{
    _id?: string;

    name?: string;

    squad?: Array<{}>;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/teams/{teamId}/crew/{sportnetId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    path = path.replace('{sportnetId}', sportnetId.toString());

    return this.request(
      'DELETE',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminInvitePlayerToCompetitionPartTeamSquad
   */
  adminInvitePlayerToCompetitionPartTeamSquad(
    appSpace: string,
    competitionId: string,
    partId: string,
    teamId: string,
    parameters: {} = {},
    body: {
      email: string;
    },
  ): Promise<{
    message?: string;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/teams/{teamId}/invite/players';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetCompetitionParts
   */
  adminGetCompetitionParts(
    appSpace: string,
    competitionId: string,
    parameters: {} = {},
  ): Promise<{
    parts?: Array<{
      _id: string;

      name: string;

      format?: 'points' | 'draw';

      rounds?: Array<{
        _id: string;

        name: string;

        dateFrom: string;

        dateTo: string;
      }>;

      rules?: {
        sport_sector: string;

        discipline?: string;

        gender?: string;

        bornDateFrom?: string;

        bornDateTo?: string;
      };

      dateFrom: string;

      dateTo: string;

      settings?: {};

      signup?: boolean;

      resultsTable?: {
        results: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;

            resignation?: boolean;
          };

          stats: {
            matches: {
              played: number;

              won: number;

              draw: number;

              lost: number;
            };

            goals: {
              given: number;

              received: number;
            };

            points: number;
          };

          homeStats?: {
            matches: {
              played: number;

              won: number;

              draw: number;

              lost: number;
            };

            goals: {
              given: number;

              received: number;
            };

            points: number;
          };

          awayStats?: {
            matches: {
              played: number;

              won: number;

              draw: number;

              lost: number;
            };

            goals: {
              given: number;

              received: number;
            };

            points: number;
          };

          matches?: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;
            };

            result: 'W' | 'L' | 'D';

            homeaway: 'home' | 'away';

            matchId: string;

            score: string;
          }>;

          homeMatches?: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;
            };

            result: 'W' | 'L' | 'D';

            homeaway: 'home' | 'away';

            matchId: string;

            score: string;
          }>;

          awayMatches?: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;
            };

            result: 'W' | 'L' | 'D';

            homeaway: 'home' | 'away';

            matchId: string;

            score: string;
          }>;
        }>;

        players?: Array<{
          _id: string;

          teamId: string;

          name: string;

          stats: {
            match_starts?: number;

            match_appearances?: number;

            goals?: number;

            assists?: number;

            yellow_cards?: number;

            red_cards?: number;

            substitutions?: number;

            own_goals?: number;
          };
        }>;
      };

      matches_count?: number;
    }>;
  }> {
    let path = '/admin/{appSpace}/competitions/{competitionId}/parts';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminCreateCompetitionPart
   */
  adminCreateCompetitionPart(
    appSpace: string,
    competitionId: string,
    parameters: {} = {},
    body: {
      name: string;

      type?: string;

      format?: 'points' | 'draw';

      rules?: {
        sport_sector?: string;

        discipline?: string;

        gender?: string;

        bornDateFrom?: string;

        bornDateTo?: string;

        loosePlayerSignup?: boolean;
      };

      dateFrom: string;

      dateTo: string;

      settings?: {};

      signup?: boolean;
    },
  ): Promise<{
    _id: string;

    name: string;

    rounds?: Array<{
      _id: string;

      name: string;

      dateFrom: string;

      dateTo: string;
    }>;

    rules?: {
      sport_sector: string;

      discipline?: string;

      gender?: string;

      bornDateFrom?: string;

      bornDateTo?: string;
    };

    dateFrom: string;

    dateTo: string;

    settings?: {};

    signup?: boolean;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    matches_count?: number;
  }> {
    let path = '/admin/{appSpace}/competitions/{competitionId}/parts';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetCompetitionPartById
   */
  adminGetCompetitionPartById(
    appSpace: string,
    competitionId: string,
    partId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    name: string;

    rounds?: Array<{
      _id: string;

      name: string;

      dateFrom: string;

      dateTo: string;
    }>;

    rules?: {
      sport_sector: string;

      discipline?: string;

      gender?: string;

      bornDateFrom?: string;

      bornDateTo?: string;
    };

    dateFrom: string;

    dateTo: string;

    settings?: {};

    signup?: boolean;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    matches_count?: number;
  }> {
    let path = '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminUpdateCompetitionPart
   */
  adminUpdateCompetitionPart(
    appSpace: string,
    competitionId: string,
    partId: string,
    parameters: {} = {},
    body: {
      name?: string;

      rules?: {
        sport_sector: string;

        discipline?: string;

        gender?: string;

        bornDateFrom?: string;

        bornDateTo?: string;
      };

      dateFrom?: string;

      dateTo?: string;

      settings?: {};

      resultsTable?: {};
    },
  ): Promise<{
    _id: string;

    name: string;

    rounds?: Array<{
      _id: string;

      name: string;

      dateFrom: string;

      dateTo: string;
    }>;

    rules?: {
      sport_sector: string;

      discipline?: string;

      gender?: string;

      bornDateFrom?: string;

      bornDateTo?: string;
    };

    dateFrom: string;

    dateTo: string;

    settings?: {};

    signup?: boolean;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    matches_count?: number;
  }> {
    let path = '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminDeleteCompetitionPart
   */
  adminDeleteCompetitionPart(
    appSpace: string,
    competitionId: string,
    partId: string,
    parameters: {} = {},
  ): Promise<{}> {
    let path = '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    return this.request(
      'DELETE',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminAssignClubManager
   */
  adminAssignClubManager(
    appSpace: string,
    competitionId: string,
    partId: string,
    clubId: string,
    parameters: {} = {},
    body: {
      sportnetId: string;
    },
  ): Promise<{
    message: string;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/clubs/{clubId}/clubManagers';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{clubId}', clubId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminRemoveClubManager
   */
  adminRemoveClubManager(
    appSpace: string,
    competitionId: string,
    partId: string,
    clubId: string,
    sportnetId: string,
    parameters: {} = {},
  ): Promise<{
    message: string;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/clubs/{clubId}/clubManagers/{sportnetId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{clubId}', clubId.toString());

    path = path.replace('{sportnetId}', sportnetId.toString());

    return this.request(
      'DELETE',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetCompetitionPartRounds
   */
  adminGetCompetitionPartRounds(
    appSpace: string,
    competitionId: string,
    partId: string,
    parameters: {} = {},
  ): Promise<{
    rounds: Array<{
      _id: string;

      name: string;

      dateFrom: string;

      dateTo: string;
    }>;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/rounds';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminCreateCompetitionPartRound
   */
  adminCreateCompetitionPartRound(
    appSpace: string,
    competitionId: string,
    partId: string,
    parameters: {} = {},
    body: {
      name: string;

      dateFrom: string;

      dateTo: string;
    },
  ): Promise<{
    _id: string;

    name: string;

    dateFrom: string;

    dateTo: string;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/rounds';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetOrganizationAthletes
   */
  adminGetOrganizationAthletes(
    appSpace: string,
    competitionId: string,
    partId: string,
    parameters: {
      teamId: string;
      q?: string;
    },
  ): Promise<{
    athletes?: Array<{
      sportnetId: string;

      displayName: string;

      birthyear?: string;
    }>;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/suitable-athletes';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    if (typeof parameters['teamId'] !== 'undefined') {
      queryParameters['team_id'] = parameters['teamId'];
    }

    queryParameters['team_id'] = this.transformParameter(
      queryParameters['team_id'],
    );

    if (typeof parameters['teamId'] === 'undefined') {
      throw new Error('Missing required parameter: teamId');
    }

    if (typeof parameters['q'] !== 'undefined') {
      queryParameters['q'] = parameters['q'];
    }

    queryParameters['q'] = this.transformParameter(queryParameters['q']);

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetCompetitionPartSuitableTeams
   */
  adminGetCompetitionPartSuitableTeams(
    appSpace: string,
    competitionId: string,
    partId: string,
    parameters: {
      limit?: number;
      offset?: number;
    } = {},
  ): Promise<{
    items?: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/suitable-teams';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    queryParameters['limit'] = 100;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminSignupCompetitionPartTeam
   */
  adminSignupCompetitionPartTeam(
    appSpace: string,
    competitionId: string,
    partId: string,
    parameters: {} = {},
    body: {
      teamId?: string;
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    logo?: {
      media_url: string;

      public_url: string;
    };

    smarttags?: Array<{
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    }>;

    name: string;

    displayName: string;

    gender?: string;

    sport_sector: string;

    athletes?: Array<{
      sportnetUser: {
        _id: string;

        name: string;
      };

      additionalData?: {};
    }>;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/teams';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminUpdateCompetitionPartSignedUpTeam
   */
  adminUpdateCompetitionPartSignedUpTeam(
    appSpace: string,
    competitionId: string,
    partId: string,
    teamId: string,
    parameters: {} = {},
    body: {
      logo?: {
        public_url: string;

        media_url: string;
      };
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    logo?: {
      media_url: string;

      public_url: string;
    };

    smarttags?: Array<{
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    }>;

    name: string;

    displayName: string;

    gender?: string;

    sport_sector: string;

    athletes?: Array<{
      sportnetUser: {
        _id: string;

        name: string;
      };

      additionalData?: {};
    }>;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/teams/{teamId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminRemoveCompetitionPartSignedUpTeam
   */
  adminRemoveCompetitionPartSignedUpTeam(
    appSpace: string,
    competitionId: string,
    partId: string,
    teamId: string,
    parameters: {} = {},
  ): Promise<{
    message?: string;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/teams/{teamId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'DELETE',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#externalRegistrationIntoSquad
   */
  externalRegistrationIntoSquad(
    appSpace: string,
    competitionId: string,
    partId: string,
    teamId: string,
    parameters: {} = {},
    body: {
      name: string;

      surname: string;

      type: 'sport_org' | 'sport_expert_org';

      position?: string;
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    logo?: {
      media_url: string;

      public_url: string;
    };

    smarttags?: Array<{
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    }>;

    name: string;

    displayName: string;

    gender?: string;

    sport_sector: string;

    athletes?: Array<{
      sportnetUser: {
        _id: string;

        name: string;
      };

      additionalData?: {};
    }>;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/teams/{teamId}/external-registration';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminInviteCompetitionPartClub
   */
  adminInviteCompetitionPartClub(
    appSpace: string,
    competitionId: string,
    partId: string,
    parameters: {} = {},
    body: {
      club: string;

      email: string;
    },
  ): Promise<{
    message: string;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/clubs';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getCompetitionPartCurrentResultTable
   */
  getCompetitionPartCurrentResultTable(
    appSpace: string,
    competitionId: string,
    partId: string,
    parameters: {} = {},
  ): Promise<{
    results: Array<{
      team: {
        _id: string;

        name: string;

        displayName: string;

        resignation?: boolean;
      };

      stats: {
        matches: {
          played: number;

          won: number;

          draw: number;

          lost: number;
        };

        goals: {
          given: number;

          received: number;
        };

        points: number;
      };

      homeStats?: {
        matches: {
          played: number;

          won: number;

          draw: number;

          lost: number;
        };

        goals: {
          given: number;

          received: number;
        };

        points: number;
      };

      awayStats?: {
        matches: {
          played: number;

          won: number;

          draw: number;

          lost: number;
        };

        goals: {
          given: number;

          received: number;
        };

        points: number;
      };

      matches?: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;
        };

        result: 'W' | 'L' | 'D';

        homeaway: 'home' | 'away';

        matchId: string;

        score: string;
      }>;

      homeMatches?: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;
        };

        result: 'W' | 'L' | 'D';

        homeaway: 'home' | 'away';

        matchId: string;

        score: string;
      }>;

      awayMatches?: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;
        };

        result: 'W' | 'L' | 'D';

        homeaway: 'home' | 'away';

        matchId: string;

        score: string;
      }>;
    }>;

    players?: Array<{
      _id: string;

      teamId: string;

      name: string;

      stats: {
        match_starts?: number;

        match_appearances?: number;

        goals?: number;

        assists?: number;

        yellow_cards?: number;

        red_cards?: number;

        substitutions?: number;

        own_goals?: number;
      };
    }>;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/results';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetMatches
   */
  adminGetMatches(
    appSpace: string,
    parameters: {
      limit?: number;
      offset?: number;
      closed?: string;
      seasonIds?: Array<string>;
      competitionIds?: Array<string>;
      partIds?: Array<string>;
      roundIds?: Array<string>;
    } = {},
  ): Promise<{
    limit: number;

    offset: number;

    total: number;

    nextOffset?: number;

    matches: Array<{
      _id: string;

      __issfId?: number;

      appSpace: string;

      drawId?: number;

      teams?: Array<{
        _id: string;

        appSpace: string;

        logo?: {
          media_url: string;

          public_url: string;
        };

        smarttags?: Array<{
          key: string | number;

          values: Array<{
            key: string | number;

            title?: string | null;
          }>;
        }>;

        name: string;

        displayName: string;

        gender?: string;

        sport_sector: string;

        athletes?: Array<{
          sportnetUser: {
            _id: string;

            name: string;
          };

          additionalData?: {};
        }>;
      }>;

      startDate: string;

      sportGround: {
        _id: string;

        name: string;

        sportGroundType: string;

        additionalData?: {};
      };

      settings?: {
        players: {
          field: {
            min: number;

            max: number;
          };

          substitutes: {
            max: number;
          };
        };

        contumation: {
          score: number;
        };

        reverseTime: boolean;

        overlapTime: boolean;

        phases: {};
      };

      competition: {
        _id: string;

        name: string;

        competitionGroupId: string;
      };

      competitionPart: {
        _id: string;

        name: string;
      };

      season: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      round?: {
        _id: string;

        name: string;

        dateFrom?: string;

        dateTo?: string;
      };

      closed?: boolean;

      rules?: {};

      contumation?: {
        isContumated: boolean;

        advantage: null | string;

        keepScore: boolean;
      };

      protocol?: {};

      liveState?: {
        ongoing: boolean;

        seconds: number;

        phase: string;

        toggleDate: string;
      };

      timer?: {};

      scoreIsComputed?: boolean;

      score?: Array<number>;
    }>;
  }> {
    let path = '/admin/{appSpace}/matches';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    queryParameters['limit'] = 100;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    if (typeof parameters['closed'] !== 'undefined') {
      queryParameters['closed'] = parameters['closed'];
    }

    queryParameters['closed'] = this.transformParameter(
      queryParameters['closed'],
    );

    if (typeof parameters['seasonIds'] !== 'undefined') {
      queryParameters['season_ids'] = parameters['seasonIds'];
    }

    queryParameters['season_ids'] = this.transformParameter(
      queryParameters['season_ids'],
    );

    if (typeof parameters['competitionIds'] !== 'undefined') {
      queryParameters['competition_ids'] = parameters['competitionIds'];
    }

    queryParameters['competition_ids'] = this.transformParameter(
      queryParameters['competition_ids'],
    );

    if (typeof parameters['partIds'] !== 'undefined') {
      queryParameters['part_ids'] = parameters['partIds'];
    }

    queryParameters['part_ids'] = this.transformParameter(
      queryParameters['part_ids'],
    );

    if (typeof parameters['roundIds'] !== 'undefined') {
      queryParameters['round_ids'] = parameters['roundIds'];
    }

    queryParameters['round_ids'] = this.transformParameter(
      queryParameters['round_ids'],
    );

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminCreateMatch
   */
  adminCreateMatch(
    appSpace: string,
    parameters: {} = {},
    body: {
      livestream?: string;

      ticketsUrl?: string;

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      startDate: string;

      sportGround: {
        _id: string;

        name: string;

        sportGroundType: string;

        additionalData?: {};
      };

      competitionId: string;

      partId: string;

      seasonId?: string;

      roundId?: string;

      drawId?: number;

      closed?: boolean;
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;

    startDate: string;

    sportGround: {
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    };

    competition: {
      _id: string;

      name: string;

      competitionGroupId: string;
    };

    competitionPart: {
      _id: string;

      name: string;
    };

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    round?: {
      _id?: string;

      name: string;

      dateFrom?: string;

      dateTo?: string;
    };

    nominations: Array<{
      teamId?: string;

      athletes: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;

      crew?: Array<{
        sportnetUser: {
          _id: string | null;

          name: string | null;
        };

        position: string;
      }>;

      closed?: boolean;
    }>;

    protocol?: {
      events?: Array<{}>;
    };

    rules?: {
      gender?: string;

      sport_sector?: string;

      discipline?: string;
    };

    closed?: boolean;

    contumation?: {
      isContumated: boolean;

      advantage: null | string;

      keepScore: boolean;
    };

    score?: Array<number>;

    livestream?: string;

    ticketsUrl?: string;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    settings: {
      players: {
        field: {
          min: number;

          max: number;
        };

        substitutes: {
          max: number;
        };
      };

      contumation: {
        score: number;
      };

      reverseTime: boolean;

      overlapTime: boolean;

      phases: {};
    };

    liveState?: {
      phase: string;

      seconds: number;

      ongoing: boolean;

      toggleDate: string;
    };

    drawId?: number;

    timer?: {};

    managers?: Array<{
      user: {
        _id: string;

        name: string;
      };

      type: {
        label: string;

        value: string;
      };

      grant?: boolean;
    }>;
  }> {
    let path = '/admin/{appSpace}/matches';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetMatchById
   */
  adminGetMatchById(
    appSpace: string,
    matchId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    appSpace: string;

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;

    startDate: string;

    sportGround: {
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    };

    competition: {
      _id: string;

      name: string;

      competitionGroupId: string;
    };

    competitionPart: {
      _id: string;

      name: string;
    };

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    round?: {
      _id?: string;

      name: string;

      dateFrom?: string;

      dateTo?: string;
    };

    nominations: Array<{
      teamId?: string;

      athletes: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;

      crew?: Array<{
        sportnetUser: {
          _id: string | null;

          name: string | null;
        };

        position: string;
      }>;

      closed?: boolean;
    }>;

    protocol?: {
      events?: Array<{}>;
    };

    rules?: {
      gender?: string;

      sport_sector?: string;

      discipline?: string;
    };

    closed?: boolean;

    contumation?: {
      isContumated: boolean;

      advantage: null | string;

      keepScore: boolean;
    };

    score?: Array<number>;

    livestream?: string;

    ticketsUrl?: string;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    settings: {
      players: {
        field: {
          min: number;

          max: number;
        };

        substitutes: {
          max: number;
        };
      };

      contumation: {
        score: number;
      };

      reverseTime: boolean;

      overlapTime: boolean;

      phases: {};
    };

    liveState?: {
      phase: string;

      seconds: number;

      ongoing: boolean;

      toggleDate: string;
    };

    drawId?: number;

    timer?: {};

    managers?: Array<{
      user: {
        _id: string;

        name: string;
      };

      type: {
        label: string;

        value: string;
      };

      grant?: boolean;
    }>;
  }> {
    let path = '/admin/{appSpace}/matches/{matchId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminUpdateMatch
   */
  adminUpdateMatch(
    appSpace: string,
    matchId: string,
    parameters: {} = {},
    body: {
      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      score?: Array<number>;

      livestream?: string;

      ticketsUrl?: string;

      teams?: Array<{
        _id?: string;
      }>;

      startDate: string;

      sportGround?: {
        _id: string;

        name: string;

        sportGroundType: string;

        additionalData?: {};
      };

      competitionId: string;

      partId: string;

      seasonId?: string;

      roundId?: string;

      nominations?: Array<{
        teamId?: string;

        athletes: Array<{
          sportnetUser: {
            _id: string;

            name: string;
          };

          additionalData?: {};
        }>;

        crew?: Array<{
          sportnetUser: {
            _id: string | null;

            name: string | null;
          };

          position: string;
        }>;

        closed?: boolean;
      }>;

      protocol?: {};

      rules?: {
        gender?: string;

        sport_sector?: string;
      };

      closed?: boolean;

      drawId?: number;

      timer?: {};
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;

    startDate: string;

    sportGround: {
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    };

    competition: {
      _id: string;

      name: string;

      competitionGroupId: string;
    };

    competitionPart: {
      _id: string;

      name: string;
    };

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    round?: {
      _id?: string;

      name: string;

      dateFrom?: string;

      dateTo?: string;
    };

    nominations: Array<{
      teamId?: string;

      athletes: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;

      crew?: Array<{
        sportnetUser: {
          _id: string | null;

          name: string | null;
        };

        position: string;
      }>;

      closed?: boolean;
    }>;

    protocol?: {
      events?: Array<{}>;
    };

    rules?: {
      gender?: string;

      sport_sector?: string;

      discipline?: string;
    };

    closed?: boolean;

    contumation?: {
      isContumated: boolean;

      advantage: null | string;

      keepScore: boolean;
    };

    score?: Array<number>;

    livestream?: string;

    ticketsUrl?: string;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    settings: {
      players: {
        field: {
          min: number;

          max: number;
        };

        substitutes: {
          max: number;
        };
      };

      contumation: {
        score: number;
      };

      reverseTime: boolean;

      overlapTime: boolean;

      phases: {};
    };

    liveState?: {
      phase: string;

      seconds: number;

      ongoing: boolean;

      toggleDate: string;
    };

    drawId?: number;

    timer?: {};

    managers?: Array<{
      user: {
        _id: string;

        name: string;
      };

      type: {
        label: string;

        value: string;
      };

      grant?: boolean;
    }>;
  }> {
    let path = '/admin/{appSpace}/matches/{matchId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminDeleteMatch
   */
  adminDeleteMatch(
    appSpace: string,
    matchId: string,
    parameters: {} = {},
  ): Promise<{
    message: string;
  }> {
    let path = '/admin/{appSpace}/matches/{matchId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'DELETE',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#appDeleteMatch
   */
  appDeleteMatch(
    matchId: string,
    parameters: {} = {},
  ): Promise<{
    message: string;
  }> {
    let path = '/app/matches/{matchId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'DELETE',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminAddMatchManager
   */
  adminAddMatchManager(
    appSpace: string,
    matchId: string,
    parameters: {} = {},
    body: {
      user: {
        _id: string;

        name: string;

        citizenship?: string | null;
      };

      type: {
        label: string;

        value: string;
      };

      grant?: boolean;
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;

    startDate: string;

    sportGround: {
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    };

    competition: {
      _id: string;

      name: string;

      competitionGroupId: string;
    };

    competitionPart: {
      _id: string;

      name: string;
    };

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    round?: {
      _id?: string;

      name: string;

      dateFrom?: string;

      dateTo?: string;
    };

    nominations: Array<{
      teamId?: string;

      athletes: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;

      crew?: Array<{
        sportnetUser: {
          _id: string | null;

          name: string | null;
        };

        position: string;
      }>;

      closed?: boolean;
    }>;

    protocol?: {
      events?: Array<{}>;
    };

    rules?: {
      gender?: string;

      sport_sector?: string;

      discipline?: string;
    };

    closed?: boolean;

    contumation?: {
      isContumated: boolean;

      advantage: null | string;

      keepScore: boolean;
    };

    score?: Array<number>;

    livestream?: string;

    ticketsUrl?: string;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    settings: {
      players: {
        field: {
          min: number;

          max: number;
        };

        substitutes: {
          max: number;
        };
      };

      contumation: {
        score: number;
      };

      reverseTime: boolean;

      overlapTime: boolean;

      phases: {};
    };

    liveState?: {
      phase: string;

      seconds: number;

      ongoing: boolean;

      toggleDate: string;
    };

    drawId?: number;

    timer?: {};

    managers?: Array<{
      user: {
        _id: string;

        name: string;
      };

      type: {
        label: string;

        value: string;
      };

      grant?: boolean;
    }>;
  }> {
    let path = '/admin/{appSpace}/matches/{matchId}/managers';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminRemoveMatchManager
   */
  adminRemoveMatchManager(
    appSpace: string,
    matchId: string,
    sportnetId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    appSpace: string;

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;

    startDate: string;

    sportGround: {
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    };

    competition: {
      _id: string;

      name: string;

      competitionGroupId: string;
    };

    competitionPart: {
      _id: string;

      name: string;
    };

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    round?: {
      _id?: string;

      name: string;

      dateFrom?: string;

      dateTo?: string;
    };

    nominations: Array<{
      teamId?: string;

      athletes: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;

      crew?: Array<{
        sportnetUser: {
          _id: string | null;

          name: string | null;
        };

        position: string;
      }>;

      closed?: boolean;
    }>;

    protocol?: {
      events?: Array<{}>;
    };

    rules?: {
      gender?: string;

      sport_sector?: string;

      discipline?: string;
    };

    closed?: boolean;

    contumation?: {
      isContumated: boolean;

      advantage: null | string;

      keepScore: boolean;
    };

    score?: Array<number>;

    livestream?: string;

    ticketsUrl?: string;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    settings: {
      players: {
        field: {
          min: number;

          max: number;
        };

        substitutes: {
          max: number;
        };
      };

      contumation: {
        score: number;
      };

      reverseTime: boolean;

      overlapTime: boolean;

      phases: {};
    };

    liveState?: {
      phase: string;

      seconds: number;

      ongoing: boolean;

      toggleDate: string;
    };

    drawId?: number;

    timer?: {};

    managers?: Array<{
      user: {
        _id: string;

        name: string;
      };

      type: {
        label: string;

        value: string;
      };

      grant?: boolean;
    }>;
  }> {
    let path = '/admin/{appSpace}/matches/{matchId}/managers/{sportnetId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    path = path.replace('{sportnetId}', sportnetId.toString());

    return this.request(
      'DELETE',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminUpdateMatchContumation
   */
  adminUpdateMatchContumation(
    appSpace: string,
    matchId: string,
    parameters: {} = {},
    body: {
      isContumated: boolean;

      advantage: null | string;

      keepScore: boolean;
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;

    startDate: string;

    sportGround: {
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    };

    competition: {
      _id: string;

      name: string;

      competitionGroupId: string;
    };

    competitionPart: {
      _id: string;

      name: string;
    };

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    round?: {
      _id?: string;

      name: string;

      dateFrom?: string;

      dateTo?: string;
    };

    nominations: Array<{
      teamId?: string;

      athletes: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;

      crew?: Array<{
        sportnetUser: {
          _id: string | null;

          name: string | null;
        };

        position: string;
      }>;

      closed?: boolean;
    }>;

    protocol?: {
      events?: Array<{}>;
    };

    rules?: {
      gender?: string;

      sport_sector?: string;

      discipline?: string;
    };

    closed?: boolean;

    contumation?: {
      isContumated: boolean;

      advantage: null | string;

      keepScore: boolean;
    };

    score?: Array<number>;

    livestream?: string;

    ticketsUrl?: string;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    settings: {
      players: {
        field: {
          min: number;

          max: number;
        };

        substitutes: {
          max: number;
        };
      };

      contumation: {
        score: number;
      };

      reverseTime: boolean;

      overlapTime: boolean;

      phases: {};
    };

    liveState?: {
      phase: string;

      seconds: number;

      ongoing: boolean;

      toggleDate: string;
    };

    drawId?: number;

    timer?: {};

    managers?: Array<{
      user: {
        _id: string;

        name: string;
      };

      type: {
        label: string;

        value: string;
      };

      grant?: boolean;
    }>;
  }> {
    let path = '/admin/{appSpace}/matches/{matchId}/contumation';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetMatchSuitableTeams
   */
  adminGetMatchSuitableTeams(
    appSpace: string,
    matchId: string,
    parameters: {
      limit?: number;
      offset?: number;
    } = {},
  ): Promise<{
    limit: number;

    offset: number;

    total: number;

    nextOffset?: number;

    teams: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;
  }> {
    let path = '/admin/{appSpace}/matches/{matchId}/suitable-teams';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    queryParameters['limit'] = 100;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetMatchNominations
   */
  adminGetMatchNominations(
    appSpace: string,
    matchId: string,
    teamId: string,
    parameters: {} = {},
  ): Promise<{
    teamId?: string;

    athletes: Array<{
      sportnetUser: {
        _id: string;

        name: string;
      };

      additionalData?: {};
    }>;

    crew?: Array<{
      sportnetUser: {
        _id: string | null;

        name: string | null;
      };

      position: string;
    }>;

    closed?: boolean;
  }> {
    let path = '/admin/{appSpace}/matches/{matchId}/nominations/{teamId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminPutMatchNominations
   */
  adminPutMatchNominations(
    appSpace: string,
    matchId: string,
    teamId: string,
    parameters: {} = {},
    body: {
      teamId?: string;

      athletes: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;

      crew?: Array<{
        sportnetUser: {
          _id: string | null;

          name: string | null;
        };

        position: string;
      }>;

      closed?: boolean;
    },
  ): Promise<{}> {
    let path = '/admin/{appSpace}/matches/{matchId}/nominations/{teamId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#externalRegistrationIntoNomination
   */
  externalRegistrationIntoNomination(
    appSpace: string,
    matchId: string,
    teamId: string,
    parameters: {} = {},
    body: {
      name?: string;

      surname?: string;
    },
  ): Promise<{
    message: string;
  }> {
    let path =
      '/admin/{appSpace}/matches/{matchId}/nominations/{teamId}/external-registration';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#externalRegistrationDelegate
   */
  externalRegistrationDelegate(
    appSpace: string,
    matchId: string,
    parameters: {} = {},
    body: {
      name?: string;

      surname?: string;
    },
  ): Promise<{
    message: string;
  }> {
    let path =
      '/admin/{appSpace}/matches/{matchId}/delegates-external-registration';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetMatchProtocol
   */
  adminGetMatchProtocol(
    appSpace: string,
    matchId: string,
    parameters: {} = {},
  ): Promise<{}> {
    let path = '/admin/{appSpace}/matches/{matchId}/protocol';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminUpdateMatchLiveState
   */
  adminUpdateMatchLiveState(
    appSpace: string,
    matchId: string,
    parameters: {} = {},
    body: {
      liveState: {
        phase: string;

        seconds: number;

        ongoing: boolean;

        toggleDate: string;
      };

      timer?: {};
    },
  ): Promise<{
    phase: string;

    seconds: number;

    ongoing: boolean;

    toggleDate: string;
  }> {
    let path = '/admin/{appSpace}/matches/{matchId}/liveState';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#regenerateMatchCompetitionPartResults
   */
  regenerateMatchCompetitionPartResults(
    appSpace: string,
    matchId: string,
    parameters: {
      regenerateAll?: boolean;
    } = {},
  ): Promise<{}> {
    let path = '/admin/{appSpace}/matches/{matchId}/regenerate';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    if (typeof parameters['regenerateAll'] !== 'undefined') {
      queryParameters['regenerateAll'] = parameters['regenerateAll'];
    }

    queryParameters['regenerateAll'] = this.transformParameter(
      queryParameters['regenerateAll'],
    );

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetOrganizationSportExperts
   */
  adminGetOrganizationSportExperts(
    appSpace: string,
    parameters: {
      q?: string;
      teamId?: string;
    } = {},
  ): Promise<{
    sportExperts?: Array<{
      sportnetId: string;

      displayName: string;

      birthyear?: string;
    }>;
  }> {
    let path = '/admin/{appSpace}/sport-experts';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    if (typeof parameters['q'] !== 'undefined') {
      queryParameters['q'] = parameters['q'];
    }

    queryParameters['q'] = this.transformParameter(queryParameters['q']);

    path = path.replace('{appSpace}', appSpace.toString());

    if (typeof parameters['teamId'] !== 'undefined') {
      queryParameters['team_id'] = parameters['teamId'];
    }

    queryParameters['team_id'] = this.transformParameter(
      queryParameters['team_id'],
    );

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetRecords
   */
  adminGetRecords(
    appSpace: string,
    parameters: {
      gender?: string;
      ageCategoryId?: string;
      disciplineName?: string;
      disciplineParameters?: Array<string>;
    } = {},
  ): Promise<{
    items: Array<{
      _id: string;

      gender: string;

      sport: string;

      records: Array<{
        place: string;

        date: string;

        record: {
          type: string;

          value: string;
        };

        holders: Array<{
          _id: string;

          name: string;
        }>;

        club: {
          _id: string;

          name: string;
        };
      }>;

      ageCategory: {
        _id: string;

        name: string;
      };

      discipline: {
        _id: string;

        name: string;

        parameters: Array<{
          _id: string;

          name: string;

          value: string;
        }>;
      };
    }>;
  }> {
    let path = '/admin/{appSpace}/records';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    if (typeof parameters['gender'] !== 'undefined') {
      queryParameters['gender'] = parameters['gender'];
    }

    queryParameters['gender'] = this.transformParameter(
      queryParameters['gender'],
    );

    if (typeof parameters['ageCategoryId'] !== 'undefined') {
      queryParameters['ageCategoryId'] = parameters['ageCategoryId'];
    }

    queryParameters['ageCategoryId'] = this.transformParameter(
      queryParameters['ageCategoryId'],
    );

    if (typeof parameters['disciplineName'] !== 'undefined') {
      queryParameters['disciplineName'] = parameters['disciplineName'];
    }

    queryParameters['disciplineName'] = this.transformParameter(
      queryParameters['disciplineName'],
    );

    if (typeof parameters['disciplineParameters'] !== 'undefined') {
      queryParameters['disciplineParameters'] =
        parameters['disciplineParameters'];
    }

    queryParameters['disciplineParameters'] = this.transformParameter(
      queryParameters['disciplineParameters'],
    );

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminCreateRecord
   */
  adminCreateRecord(
    appSpace: string,
    parameters: {} = {},
    body: {
      sport: string;

      gender: string;

      ageCategory: {
        _id: string;

        name: string;
      };

      discipline: {
        _id: string;

        name: string;

        parameters: Array<{
          _id: string;

          name: string;

          value: string;
        }>;
      };

      records: Array<{
        place: string;

        date: string;

        record: {
          type: string;

          value: string;
        };

        holders: Array<{
          _id: string;

          name: string;
        }>;

        club: {
          _id: string;

          name: string;
        };
      }>;
    },
  ): Promise<{
    _id: string;

    gender: string;

    sport: string;

    records: Array<{
      place: string;

      date: string;

      record: {
        type: string;

        value: string;
      };

      holders: Array<{
        _id: string;

        name: string;
      }>;

      club: {
        _id: string;

        name: string;
      };
    }>;

    ageCategory: {
      _id: string;

      name: string;
    };

    discipline: {
      _id: string;

      name: string;

      parameters: Array<{
        _id: string;

        name: string;

        value: string;
      }>;
    };
  }> {
    let path = '/admin/{appSpace}/records';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetRecordById
   */
  adminGetRecordById(
    appSpace: string,
    recordId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    gender: string;

    sport: string;

    records: Array<{
      place: string;

      date: string;

      record: {
        type: string;

        value: string;
      };

      holders: Array<{
        _id: string;

        name: string;
      }>;

      club: {
        _id: string;

        name: string;
      };
    }>;

    ageCategory: {
      _id: string;

      name: string;
    };

    discipline: {
      _id: string;

      name: string;

      parameters: Array<{
        _id: string;

        name: string;

        value: string;
      }>;
    };
  }> {
    let path = '/admin/{appSpace}/records/{recordId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{recordId}', recordId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminUpdateRecord
   */
  adminUpdateRecord(
    appSpace: string,
    recordId: string,
    parameters: {} = {},
    body: {
      records: Array<{
        place: string;

        date: string;

        record: {
          type: string;

          value: string | number;
        };

        holders: Array<{
          _id: string | null;

          name: string;
        }>;

        club: {
          _id: string | null;

          name: string;
        };
      }>;
    },
  ): Promise<{
    _id: string;

    gender: string;

    sport: string;

    records: Array<{
      place: string;

      date: string;

      record: {
        type: string;

        value: string;
      };

      holders: Array<{
        _id: string;

        name: string;
      }>;

      club: {
        _id: string;

        name: string;
      };
    }>;

    ageCategory: {
      _id: string;

      name: string;
    };

    discipline: {
      _id: string;

      name: string;

      parameters: Array<{
        _id: string;

        name: string;

        value: string;
      }>;
    };
  }> {
    let path = '/admin/{appSpace}/records/{recordId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{recordId}', recordId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#adminGetRecordsAgeCategories
   */
  adminGetRecordsAgeCategories(
    appSpace: string,
    parameters: {} = {},
  ): Promise<{
    items: Array<{
      _id: string | null;

      name: string;
    }>;
  }> {
    let path = '/admin/{appSpace}/records-agecategories';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   * Get Contentspace Details
   * @method
   * @name Api#adminGetSettings
   */
  adminGetSettings(
    appSpace: string,
    parameters: {} = {},
  ): Promise<{
    domain?: string;

    homepageSectionIdOrUniqId?: string;
  }> {
    let path = '/admin/{appSpace}/settings';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   * Edit Contentspace Settings
   * @method
   * @name Api#adminEditSettings
   */
  adminEditSettings(
    appSpace: string,
    parameters: {} = {},
    body: {
      domain?: string;

      homepageSectionIdOrUniqId?: string;
    },
  ): Promise<{
    domain?: string;

    homepageSectionIdOrUniqId?: string;
  }> {
    let path = '/admin/{appSpace}/settings';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#notifyMatchChange
   */
  notifyMatchChange(
    matchId: string,
    competitionId: string,
    parameters: {} = {},
  ): Promise<{}> {
    let path = '/competitions/{competitionId}/matches/{matchId}/notify-change';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{matchId}', matchId.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getClubInvitations
   */
  getClubInvitations(
    appSpace: string,
    competitionId: string,
    partId: string,
    parameters: {} = {},
  ): Promise<{
    invitations: Array<{
      _id: string;

      appId: string;

      createdDT: string;

      ppo: string;

      title: string;

      description: string;

      email: string;

      callback: string;

      expiration: string | null;

      payload?: {};

      status?: string;

      sportnetId?: string;

      resolved?: {
        dt?: string;

        ip?: string | null;

        ips?: Array<string | null> | null;

        userAgent?: string | null;
      };

      pending?: {
        status?: string;

        sportnetId?: string;
      };

      exitUrl?: {
        accepted?: string;

        rejected?: string;
      };

      senderUser?: {
        sportnetId?: string;

        displayName?: string;
      };
    }>;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/club-invitations';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#processClubInvitationResponse
   */
  processClubInvitationResponse(
    appSpace: string,
    competitionId: string,
    partId: string,
    invitationId: string,
    parameters: {} = {},
  ): Promise<{
    message: string;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/club-invitations/{invitationId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{invitationId}', invitationId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#processPlayerInvitationResponse
   */
  processPlayerInvitationResponse(
    appSpace: string,
    competitionId: string,
    partId: string,
    invitationId: string,
    parameters: {} = {},
  ): Promise<{
    message: string;
  }> {
    let path =
      '/admin/{appSpace}/competitions/{competitionId}/parts/{partId}/player-invitations/{invitationId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{invitationId}', invitationId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#clubManagerGetCompetitionParts
   */
  clubManagerGetCompetitionParts(
    parameters: {
      dateTo?: string;
      appSpace?: string;
    } = {},
  ): Promise<{
    parts: Array<{
      _id: string;

      name: string;

      competition: {
        _id: string;

        name: string;
      };

      dateFrom: string;

      dateTo: string;

      appSpace: string;

      teamNominated: {
        _id: string;

        name: string;
      };

      squadNominated: boolean;
    }>;
  }> {
    let path = '/club-manager/parts';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    if (typeof parameters['dateTo'] !== 'undefined') {
      queryParameters['dateTo'] = parameters['dateTo'];
    }

    queryParameters['dateTo'] = this.transformParameter(
      queryParameters['dateTo'],
    );

    if (typeof parameters['appSpace'] !== 'undefined') {
      queryParameters['appSpace'] = parameters['appSpace'];
    }

    queryParameters['appSpace'] = this.transformParameter(
      queryParameters['appSpace'],
    );

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#clubManagerGetCompetition
   */
  clubManagerGetCompetition(
    competitionId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    competitionGroupId: string;

    homepageSectionIdOrUniqId?: string;

    appSpace: string;

    name: string;

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    sport: string;

    parts?: Array<{
      _id: string;

      name: string;

      rounds?: Array<{
        _id: string;

        name: string;

        dateFrom: string;

        dateTo: string;
      }>;

      rules?: {};

      settings?: {};

      signup?: boolean;

      resultsTable?: {
        results: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;

            resignation?: boolean;
          };

          stats: {
            matches: {
              played: number;

              won: number;

              draw: number;

              lost: number;
            };

            goals: {
              given: number;

              received: number;
            };

            points: number;
          };

          homeStats?: {
            matches: {
              played: number;

              won: number;

              draw: number;

              lost: number;
            };

            goals: {
              given: number;

              received: number;
            };

            points: number;
          };

          awayStats?: {
            matches: {
              played: number;

              won: number;

              draw: number;

              lost: number;
            };

            goals: {
              given: number;

              received: number;
            };

            points: number;
          };

          matches?: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;
            };

            result: 'W' | 'L' | 'D';

            homeaway: 'home' | 'away';

            matchId: string;

            score: string;
          }>;

          homeMatches?: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;
            };

            result: 'W' | 'L' | 'D';

            homeaway: 'home' | 'away';

            matchId: string;

            score: string;
          }>;

          awayMatches?: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;
            };

            result: 'W' | 'L' | 'D';

            homeaway: 'home' | 'away';

            matchId: string;

            score: string;
          }>;
        }>;

        players?: Array<{
          _id: string;

          teamId: string;

          name: string;

          stats: {
            match_starts?: number;

            match_appearances?: number;

            goals?: number;

            assists?: number;

            yellow_cards?: number;

            red_cards?: number;

            substitutions?: number;

            own_goals?: number;
          };
        }>;
      };

      matches_count?: number;

      dateFrom: string;

      dateTo: string;
    }>;

    signup?: boolean;

    publication?: {};

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams?: Array<{
      _id: string;

      name: string;

      appSpace: string;
    }>;
  }> {
    let path = '/club-manager/competitions/{competitionId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#clubManagerGetCompetitionPartById
   */
  clubManagerGetCompetitionPartById(
    competitionId: string,
    partId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    name: string;

    rounds?: Array<{
      _id: string;

      name: string;

      dateFrom: string;

      dateTo: string;
    }>;

    rules?: {
      sport_sector: string;

      discipline?: string;

      gender?: string;

      bornDateFrom?: string;

      bornDateTo?: string;
    };

    dateFrom: string;

    dateTo: string;

    settings?: {};

    signup?: boolean;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    matches_count?: number;

    teams?: Array<{
      _id: string;

      name: string;

      appSpace: string;
    }>;
  }> {
    let path = '/club-manager/competitions/{competitionId}/parts/{partId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#clubManagerUpdateCompetitionSmarttags
   */
  clubManagerUpdateCompetitionSmarttags(
    competitionId: string,
    partId: string,
    clubId: string,
    parameters: {} = {},
    body: {
      smarttags?: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    },
  ): Promise<{
    _id: string;

    competitionGroupId: string;

    homepageSectionIdOrUniqId?: string;

    appSpace: string;

    name: string;

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    sport: string;

    parts?: Array<{
      _id: string;

      name: string;

      rounds?: Array<{
        _id: string;

        name: string;

        dateFrom: string;

        dateTo: string;
      }>;

      rules?: {};

      settings?: {};

      signup?: boolean;

      resultsTable?: {
        results: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;

            resignation?: boolean;
          };

          stats: {
            matches: {
              played: number;

              won: number;

              draw: number;

              lost: number;
            };

            goals: {
              given: number;

              received: number;
            };

            points: number;
          };

          homeStats?: {
            matches: {
              played: number;

              won: number;

              draw: number;

              lost: number;
            };

            goals: {
              given: number;

              received: number;
            };

            points: number;
          };

          awayStats?: {
            matches: {
              played: number;

              won: number;

              draw: number;

              lost: number;
            };

            goals: {
              given: number;

              received: number;
            };

            points: number;
          };

          matches?: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;
            };

            result: 'W' | 'L' | 'D';

            homeaway: 'home' | 'away';

            matchId: string;

            score: string;
          }>;

          homeMatches?: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;
            };

            result: 'W' | 'L' | 'D';

            homeaway: 'home' | 'away';

            matchId: string;

            score: string;
          }>;

          awayMatches?: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;
            };

            result: 'W' | 'L' | 'D';

            homeaway: 'home' | 'away';

            matchId: string;

            score: string;
          }>;
        }>;

        players?: Array<{
          _id: string;

          teamId: string;

          name: string;

          stats: {
            match_starts?: number;

            match_appearances?: number;

            goals?: number;

            assists?: number;

            yellow_cards?: number;

            red_cards?: number;

            substitutions?: number;

            own_goals?: number;
          };
        }>;
      };

      matches_count?: number;

      dateFrom: string;

      dateTo: string;
    }>;

    signup?: boolean;

    publication?: {};

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams?: Array<{
      _id: string;

      name: string;

      appSpace: string;
    }>;
  }> {
    let path =
      '/club-manager/competitions/{competitionId}/parts/{partId}/club/{clubId}/smarttags';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{clubId}', clubId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#clubManagerGetCompetitionPartEligibleTeams
   */
  clubManagerGetCompetitionPartEligibleTeams(
    competitionId: string,
    partId: string,
    clubId: string,
    parameters: {} = {},
  ): Promise<{
    limit: number;

    offset: number;

    total: number;

    nextOffset?: number;

    items: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;
  }> {
    let path =
      '/club-manager/competitions/{competitionId}/parts/{partId}/club/{clubId}/teams';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{clubId}', clubId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#clubManagerSignupCompetitionPartTeam
   */
  clubManagerSignupCompetitionPartTeam(
    competitionId: string,
    partId: string,
    clubId: string,
    parameters: {} = {},
    body: {
      teamId?: string;
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    logo?: {
      media_url: string;

      public_url: string;
    };

    smarttags?: Array<{
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    }>;

    name: string;

    displayName: string;

    gender?: string;

    sport_sector: string;

    athletes?: Array<{
      sportnetUser: {
        _id: string;

        name: string;
      };

      additionalData?: {};
    }>;
  }> {
    let path =
      '/club-manager/competitions/{competitionId}/parts/{partId}/club/{clubId}/teams';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{clubId}', clubId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#clubManagerCreateTeam
   */
  clubManagerCreateTeam(
    competitionId: string,
    partId: string,
    clubId: string,
    parameters: {} = {},
    body: {
      _id?: string;

      appSpace?: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    logo?: {
      media_url: string;

      public_url: string;
    };

    smarttags?: Array<{
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    }>;

    name: string;

    displayName: string;

    gender?: string;

    sport_sector: string;

    athletes?: Array<{
      sportnetUser: {
        _id: string;

        name: string;
      };

      additionalData?: {};
    }>;
  }> {
    let path =
      '/club-manager/competitions/{competitionId}/parts/{partId}/club/{clubId}/team';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{clubId}', clubId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#clubManagerGetOrganizationAthletes
   */
  clubManagerGetOrganizationAthletes(
    clubId: string,
    competitionId: string,
    partId: string,
    parameters: {
      teamId: string;
      q?: string;
    },
  ): Promise<{
    athletes?: Array<{
      sportnetId: string;

      displayName: string;

      birthyear?: string;
    }>;
  }> {
    let path =
      '/club-manager/competitions/{competitionId}/parts/{partId}/club/{clubId}/suitable-athletes';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{clubId}', clubId.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    if (typeof parameters['teamId'] !== 'undefined') {
      queryParameters['team_id'] = parameters['teamId'];
    }

    queryParameters['team_id'] = this.transformParameter(
      queryParameters['team_id'],
    );

    if (typeof parameters['teamId'] === 'undefined') {
      throw new Error('Missing required parameter: teamId');
    }

    if (typeof parameters['q'] !== 'undefined') {
      queryParameters['q'] = parameters['q'];
    }

    queryParameters['q'] = this.transformParameter(queryParameters['q']);

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#clubManagerGetCompetitionPartTeamSquad
   */
  clubManagerGetCompetitionPartTeamSquad(
    competitionId: string,
    partId: string,
    teamId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    name: string;

    type?: string;

    sport_sector: string;

    squad?: {
      athletes?: Array<{
        additionalProperties?: {};

        sportnetUser: {
          _id: string;

          name: string;
        };
      }>;
    };
  }> {
    let path =
      '/club-manager/competitions/{competitionId}/parts/{partId}/teams/{teamId}/players';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#clubManagerAddPlayerToCompetitionPartTeamSquad
   */
  clubManagerAddPlayerToCompetitionPartTeamSquad(
    competitionId: string,
    partId: string,
    teamId: string,
    parameters: {} = {},
    body: {
      sportnetId?: string;

      additionalData?: {};
    },
  ): Promise<{
    _id?: string;

    name?: string;

    squad?: Array<{}>;
  }> {
    let path =
      '/club-manager/competitions/{competitionId}/parts/{partId}/teams/{teamId}/players';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#clubManagerEditPlayerInCompetitionPartTeamSquad
   */
  clubManagerEditPlayerInCompetitionPartTeamSquad(
    clubId: string,
    competitionId: string,
    partId: string,
    teamId: string,
    sportnetId: string,
    parameters: {} = {},
    body: {
      additionalData?: {};
    },
  ): Promise<{
    _id?: string;

    name?: string;

    squad?: Array<{}>;
  }> {
    let path =
      '/club-manager/competitions/{competitionId}/parts/{partId}/club/{clubId}/teams/{teamId}/players/{sportnetId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{clubId}', clubId.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    path = path.replace('{sportnetId}', sportnetId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#clubManagerRemovePlayerFromCompetitionPartTeamSquad
   */
  clubManagerRemovePlayerFromCompetitionPartTeamSquad(
    clubId: string,
    competitionId: string,
    partId: string,
    teamId: string,
    sportnetId: string,
    parameters: {} = {},
  ): Promise<{
    _id?: string;

    name?: string;

    squad?: Array<{}>;
  }> {
    let path =
      '/club-manager/competitions/{competitionId}/parts/{partId}/club/{clubId}/teams/{teamId}/players/{sportnetId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{clubId}', clubId.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    path = path.replace('{sportnetId}', sportnetId.toString());

    return this.request(
      'DELETE',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#clubManagerInvitePlayerToCompetitionPartTeamSquad
   */
  clubManagerInvitePlayerToCompetitionPartTeamSquad(
    clubId: string,
    competitionId: string,
    partId: string,
    teamId: string,
    parameters: {} = {},
    body: {
      email: string;
    },
  ): Promise<{
    message?: string;
  }> {
    let path =
      '/club-manager/competitions/{competitionId}/parts/{partId}/club/{clubId}/teams/{teamId}/invite/players';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{clubId}', clubId.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#clubManagerAddCrewMemberToCompetitionPartTeamSquad
   */
  clubManagerAddCrewMemberToCompetitionPartTeamSquad(
    competitionId: string,
    partId: string,
    teamId: string,
    parameters: {} = {},
    body: {
      sportnetId?: string;

      position?: string;
    },
  ): Promise<{
    _id?: string;

    name?: string;

    squad?: Array<{}>;
  }> {
    let path =
      '/club-manager/competitions/{competitionId}/parts/{partId}/teams/{teamId}/crew';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#clubManagerEditCrewMemberInCompetitionPartTeamSquad
   */
  clubManagerEditCrewMemberInCompetitionPartTeamSquad(
    competitionId: string,
    partId: string,
    teamId: string,
    sportnetId: string,
    parameters: {} = {},
    body: {
      position?: string;
    },
  ): Promise<{
    _id?: string;

    name?: string;

    squad?: Array<{}>;
  }> {
    let path =
      '/club-manager/competitions/{competitionId}/parts/{partId}/teams/{teamId}/crew/{sportnetId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    path = path.replace('{sportnetId}', sportnetId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#clubManagerRemoveCrewMemberFromCompetitionPartTeamSquad
   */
  clubManagerRemoveCrewMemberFromCompetitionPartTeamSquad(
    competitionId: string,
    partId: string,
    teamId: string,
    sportnetId: string,
    parameters: {} = {},
  ): Promise<{
    _id?: string;

    name?: string;

    squad?: Array<{}>;
  }> {
    let path =
      '/club-manager/competitions/{competitionId}/parts/{partId}/teams/{teamId}/crew/{sportnetId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    path = path.replace('{sportnetId}', sportnetId.toString());

    return this.request(
      'DELETE',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#clubManagerGetMatches
   */
  clubManagerGetMatches(
    parameters: {
      limit?: number;
      offset?: number;
      dateFrom?: string;
      dateTo?: string;
    } = {},
  ): Promise<{
    limit: number;

    offset: number;

    total: number;

    nextOffset?: number;

    matches: Array<{
      _id: string;

      __issfId?: number;

      appSpace: string;

      drawId?: number;

      teams?: Array<{
        _id: string;

        appSpace: string;

        logo?: {
          media_url: string;

          public_url: string;
        };

        smarttags?: Array<{
          key: string | number;

          values: Array<{
            key: string | number;

            title?: string | null;
          }>;
        }>;

        name: string;

        displayName: string;

        gender?: string;

        sport_sector: string;

        athletes?: Array<{
          sportnetUser: {
            _id: string;

            name: string;
          };

          additionalData?: {};
        }>;
      }>;

      startDate: string;

      sportGround: {
        _id: string;

        name: string;

        sportGroundType: string;

        additionalData?: {};
      };

      settings?: {
        players: {
          field: {
            min: number;

            max: number;
          };

          substitutes: {
            max: number;
          };
        };

        contumation: {
          score: number;
        };

        reverseTime: boolean;

        overlapTime: boolean;

        phases: {};
      };

      competition: {
        _id: string;

        name: string;

        competitionGroupId: string;
      };

      competitionPart: {
        _id: string;

        name: string;
      };

      season: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      round?: {
        _id: string;

        name: string;

        dateFrom?: string;

        dateTo?: string;
      };

      closed?: boolean;

      rules?: {};

      contumation?: {
        isContumated: boolean;

        advantage: null | string;

        keepScore: boolean;
      };

      protocol?: {};

      liveState?: {
        ongoing: boolean;

        seconds: number;

        phase: string;

        toggleDate: string;
      };

      timer?: {};

      managedTeamId: string;

      nominationStatus: 'EMPTY' | 'FILLED' | 'CLOSED';
    }>;
  }> {
    let path = '/club-manager/matches';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    queryParameters['limit'] = 100;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    if (typeof parameters['dateFrom'] !== 'undefined') {
      queryParameters['dateFrom'] = parameters['dateFrom'];
    }

    queryParameters['dateFrom'] = this.transformParameter(
      queryParameters['dateFrom'],
    );

    if (typeof parameters['dateTo'] !== 'undefined') {
      queryParameters['dateTo'] = parameters['dateTo'];
    }

    queryParameters['dateTo'] = this.transformParameter(
      queryParameters['dateTo'],
    );

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#clubManagerGetMatchById
   */
  clubManagerGetMatchById(
    competitionId: string,
    partId: string,
    matchId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    appSpace: string;

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;

    startDate: string;

    sportGround: {
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    };

    competition: {
      _id: string;

      name: string;

      competitionGroupId: string;
    };

    competitionPart: {
      _id: string;

      name: string;
    };

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    round?: {
      _id?: string;

      name: string;

      dateFrom?: string;

      dateTo?: string;
    };

    nominations: Array<{
      teamId?: string;

      athletes: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;

      crew?: Array<{
        sportnetUser: {
          _id: string | null;

          name: string | null;
        };

        position: string;
      }>;

      closed?: boolean;
    }>;

    protocol?: {
      events?: Array<{}>;
    };

    rules?: {
      gender?: string;

      sport_sector?: string;

      discipline?: string;
    };

    closed?: boolean;

    contumation?: {
      isContumated: boolean;

      advantage: null | string;

      keepScore: boolean;
    };

    score?: Array<number>;

    livestream?: string;

    ticketsUrl?: string;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    settings: {
      players: {
        field: {
          min: number;

          max: number;
        };

        substitutes: {
          max: number;
        };
      };

      contumation: {
        score: number;
      };

      reverseTime: boolean;

      overlapTime: boolean;

      phases: {};
    };

    liveState?: {
      phase: string;

      seconds: number;

      ongoing: boolean;

      toggleDate: string;
    };

    drawId?: number;

    timer?: {};

    managers?: Array<{
      user: {
        _id: string;

        name: string;
      };

      type: {
        label: string;

        value: string;
      };

      grant?: boolean;
    }>;
  }> {
    let path =
      '/club-manager/competitions/{competitionId}/parts/{partId}/matches/{matchId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#clubManagerUpdateMatchSmarttags
   */
  clubManagerUpdateMatchSmarttags(
    competitionId: string,
    partId: string,
    matchId: string,
    teamId: string,
    parameters: {} = {},
    body: {
      smarttags?: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;

    startDate: string;

    sportGround: {
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    };

    competition: {
      _id: string;

      name: string;

      competitionGroupId: string;
    };

    competitionPart: {
      _id: string;

      name: string;
    };

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    round?: {
      _id?: string;

      name: string;

      dateFrom?: string;

      dateTo?: string;
    };

    nominations: Array<{
      teamId?: string;

      athletes: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;

      crew?: Array<{
        sportnetUser: {
          _id: string | null;

          name: string | null;
        };

        position: string;
      }>;

      closed?: boolean;
    }>;

    protocol?: {
      events?: Array<{}>;
    };

    rules?: {
      gender?: string;

      sport_sector?: string;

      discipline?: string;
    };

    closed?: boolean;

    contumation?: {
      isContumated: boolean;

      advantage: null | string;

      keepScore: boolean;
    };

    score?: Array<number>;

    livestream?: string;

    ticketsUrl?: string;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    settings: {
      players: {
        field: {
          min: number;

          max: number;
        };

        substitutes: {
          max: number;
        };
      };

      contumation: {
        score: number;
      };

      reverseTime: boolean;

      overlapTime: boolean;

      phases: {};
    };

    liveState?: {
      phase: string;

      seconds: number;

      ongoing: boolean;

      toggleDate: string;
    };

    drawId?: number;

    timer?: {};

    managers?: Array<{
      user: {
        _id: string;

        name: string;
      };

      type: {
        label: string;

        value: string;
      };

      grant?: boolean;
    }>;
  }> {
    let path =
      '/club-manager/competitions/{competitionId}/parts/{partId}/matches/{matchId}/team/{teamId}/smarttags';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{matchId}', matchId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#clubManagerGetMatchNominations
   */
  clubManagerGetMatchNominations(
    competitionId: string,
    partId: string,
    matchId: string,
    teamId: string,
    parameters: {} = {},
  ): Promise<{
    teamId?: string;

    athletes: Array<{
      sportnetUser: {
        _id: string;

        name: string;
      };

      additionalData?: {};
    }>;

    crew?: Array<{
      sportnetUser: {
        _id: string | null;

        name: string | null;
      };

      position: string;
    }>;

    closed?: boolean;
  }> {
    let path =
      '/club-manager/competitions/{competitionId}/parts/{partId}/matches/{matchId}/nominations/{teamId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{matchId}', matchId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#clubManagerPutMatchNominations
   */
  clubManagerPutMatchNominations(
    competitionId: string,
    partId: string,
    matchId: string,
    teamId: string,
    parameters: {} = {},
    body: {
      teamId?: string;

      athletes: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;

      crew?: Array<{
        sportnetUser: {
          _id: string | null;

          name: string | null;
        };

        position: string;
      }>;

      closed?: boolean;
    },
  ): Promise<{}> {
    let path =
      '/club-manager/competitions/{competitionId}/parts/{partId}/matches/{matchId}/nominations/{teamId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{matchId}', matchId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#clubManagerGetOrganizationSportExperts
   */
  clubManagerGetOrganizationSportExperts(
    competitionId: string,
    partId: string,
    teamId: string,
    parameters: {
      q?: string;
    } = {},
  ): Promise<{
    sportExperts?: Array<{
      sportnetId: string;

      displayName: string;

      birthyear?: string;
    }>;
  }> {
    let path =
      '/club-manager/competitions/{competitionId}/parts/{partId}/teams/{teamId}/sport-experts';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    if (typeof parameters['q'] !== 'undefined') {
      queryParameters['q'] = parameters['q'];
    }

    queryParameters['q'] = this.transformParameter(queryParameters['q']);

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#matchManagerGetMatches
   */
  matchManagerGetMatches(
    parameters: {
      limit?: number;
      offset?: number;
      dateTo?: string;
    } = {},
  ): Promise<{
    limit: number;

    offset: number;

    total: number;

    nextOffset?: number;

    matches: Array<{
      _id: string;

      __issfId?: number;

      appSpace: string;

      drawId?: number;

      teams?: Array<{
        _id: string;

        appSpace: string;

        logo?: {
          media_url: string;

          public_url: string;
        };

        smarttags?: Array<{
          key: string | number;

          values: Array<{
            key: string | number;

            title?: string | null;
          }>;
        }>;

        name: string;

        displayName: string;

        gender?: string;

        sport_sector: string;

        athletes?: Array<{
          sportnetUser: {
            _id: string;

            name: string;
          };

          additionalData?: {};
        }>;
      }>;

      startDate: string;

      sportGround: {
        _id: string;

        name: string;

        sportGroundType: string;

        additionalData?: {};
      };

      settings?: {
        players: {
          field: {
            min: number;

            max: number;
          };

          substitutes: {
            max: number;
          };
        };

        contumation: {
          score: number;
        };

        reverseTime: boolean;

        overlapTime: boolean;

        phases: {};
      };

      competition: {
        _id: string;

        name: string;

        competitionGroupId: string;
      };

      competitionPart: {
        _id: string;

        name: string;
      };

      season: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      round?: {
        _id: string;

        name: string;

        dateFrom?: string;

        dateTo?: string;
      };

      closed?: boolean;

      rules?: {};

      contumation?: {
        isContumated: boolean;

        advantage: null | string;

        keepScore: boolean;
      };

      protocol?: {};

      liveState?: {
        ongoing: boolean;

        seconds: number;

        phase: string;

        toggleDate: string;
      };

      timer?: {};
    }>;
  }> {
    let path = '/match-manager/matches';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    queryParameters['limit'] = 100;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    if (typeof parameters['dateTo'] !== 'undefined') {
      queryParameters['dateTo'] = parameters['dateTo'];
    }

    queryParameters['dateTo'] = this.transformParameter(
      queryParameters['dateTo'],
    );

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#matchManagerGetCompetition
   */
  matchManagerGetCompetition(
    competitionId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    competitionGroupId: string;

    homepageSectionIdOrUniqId?: string;

    appSpace: string;

    name: string;

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    sport: string;

    parts?: Array<{
      _id: string;

      name: string;

      rounds?: Array<{
        _id: string;

        name: string;

        dateFrom: string;

        dateTo: string;
      }>;

      rules?: {};

      settings?: {};

      signup?: boolean;

      resultsTable?: {
        results: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;

            resignation?: boolean;
          };

          stats: {
            matches: {
              played: number;

              won: number;

              draw: number;

              lost: number;
            };

            goals: {
              given: number;

              received: number;
            };

            points: number;
          };

          homeStats?: {
            matches: {
              played: number;

              won: number;

              draw: number;

              lost: number;
            };

            goals: {
              given: number;

              received: number;
            };

            points: number;
          };

          awayStats?: {
            matches: {
              played: number;

              won: number;

              draw: number;

              lost: number;
            };

            goals: {
              given: number;

              received: number;
            };

            points: number;
          };

          matches?: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;
            };

            result: 'W' | 'L' | 'D';

            homeaway: 'home' | 'away';

            matchId: string;

            score: string;
          }>;

          homeMatches?: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;
            };

            result: 'W' | 'L' | 'D';

            homeaway: 'home' | 'away';

            matchId: string;

            score: string;
          }>;

          awayMatches?: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;
            };

            result: 'W' | 'L' | 'D';

            homeaway: 'home' | 'away';

            matchId: string;

            score: string;
          }>;
        }>;

        players?: Array<{
          _id: string;

          teamId: string;

          name: string;

          stats: {
            match_starts?: number;

            match_appearances?: number;

            goals?: number;

            assists?: number;

            yellow_cards?: number;

            red_cards?: number;

            substitutions?: number;

            own_goals?: number;
          };
        }>;
      };

      matches_count?: number;

      dateFrom: string;

      dateTo: string;
    }>;

    signup?: boolean;

    publication?: {};

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams?: Array<{
      _id: string;

      name: string;

      appSpace: string;
    }>;
  }> {
    let path = '/match-manager/competitions/{competitionId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#matchManagerGetCompetitionPartById
   */
  matchManagerGetCompetitionPartById(
    competitionId: string,
    partId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    name: string;

    rounds?: Array<{
      _id: string;

      name: string;

      dateFrom: string;

      dateTo: string;
    }>;

    rules?: {
      sport_sector: string;

      discipline?: string;

      gender?: string;

      bornDateFrom?: string;

      bornDateTo?: string;
    };

    dateFrom: string;

    dateTo: string;

    settings?: {};

    signup?: boolean;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    matches_count?: number;

    teams?: Array<{
      _id: string;

      name: string;

      appSpace: string;
    }>;
  }> {
    let path = '/match-manager/competitions/{competitionId}/parts/{partId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#matchManagerGetMatchById
   */
  matchManagerGetMatchById(
    competitionId: string,
    partId: string,
    matchId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    appSpace: string;

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;

    startDate: string;

    sportGround: {
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    };

    competition: {
      _id: string;

      name: string;

      competitionGroupId: string;
    };

    competitionPart: {
      _id: string;

      name: string;
    };

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    round?: {
      _id?: string;

      name: string;

      dateFrom?: string;

      dateTo?: string;
    };

    nominations: Array<{
      teamId?: string;

      athletes: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;

      crew?: Array<{
        sportnetUser: {
          _id: string | null;

          name: string | null;
        };

        position: string;
      }>;

      closed?: boolean;
    }>;

    protocol?: {
      events?: Array<{}>;
    };

    rules?: {
      gender?: string;

      sport_sector?: string;

      discipline?: string;
    };

    closed?: boolean;

    contumation?: {
      isContumated: boolean;

      advantage: null | string;

      keepScore: boolean;
    };

    score?: Array<number>;

    livestream?: string;

    ticketsUrl?: string;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    settings: {
      players: {
        field: {
          min: number;

          max: number;
        };

        substitutes: {
          max: number;
        };
      };

      contumation: {
        score: number;
      };

      reverseTime: boolean;

      overlapTime: boolean;

      phases: {};
    };

    liveState?: {
      phase: string;

      seconds: number;

      ongoing: boolean;

      toggleDate: string;
    };

    drawId?: number;

    timer?: {};

    managers?: Array<{
      user: {
        _id: string;

        name: string;
      };

      type: {
        label: string;

        value: string;
      };

      grant?: boolean;
    }>;
  }> {
    let path =
      '/match-manager/competitions/{competitionId}/parts/{partId}/matches/{matchId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#matchManagerUpdateMatch
   */
  matchManagerUpdateMatch(
    competitionId: string,
    partId: string,
    matchId: string,
    parameters: {} = {},
    body: {
      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      score?: Array<number>;

      livestream?: string;

      ticketsUrl?: string;

      teams?: Array<{
        _id?: string;
      }>;

      startDate: string;

      sportGround?: {
        _id: string;

        name: string;

        sportGroundType: string;

        additionalData?: {};
      };

      competitionId: string;

      partId: string;

      seasonId?: string;

      roundId?: string;

      nominations?: Array<{
        teamId?: string;

        athletes: Array<{
          sportnetUser: {
            _id: string;

            name: string;
          };

          additionalData?: {};
        }>;

        crew?: Array<{
          sportnetUser: {
            _id: string | null;

            name: string | null;
          };

          position: string;
        }>;

        closed?: boolean;
      }>;

      protocol?: {};

      rules?: {
        gender?: string;

        sport_sector?: string;
      };

      closed?: boolean;

      drawId?: number;

      timer?: {};
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;

    startDate: string;

    sportGround: {
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    };

    competition: {
      _id: string;

      name: string;

      competitionGroupId: string;
    };

    competitionPart: {
      _id: string;

      name: string;
    };

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    round?: {
      _id?: string;

      name: string;

      dateFrom?: string;

      dateTo?: string;
    };

    nominations: Array<{
      teamId?: string;

      athletes: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;

      crew?: Array<{
        sportnetUser: {
          _id: string | null;

          name: string | null;
        };

        position: string;
      }>;

      closed?: boolean;
    }>;

    protocol?: {
      events?: Array<{}>;
    };

    rules?: {
      gender?: string;

      sport_sector?: string;

      discipline?: string;
    };

    closed?: boolean;

    contumation?: {
      isContumated: boolean;

      advantage: null | string;

      keepScore: boolean;
    };

    score?: Array<number>;

    livestream?: string;

    ticketsUrl?: string;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    settings: {
      players: {
        field: {
          min: number;

          max: number;
        };

        substitutes: {
          max: number;
        };
      };

      contumation: {
        score: number;
      };

      reverseTime: boolean;

      overlapTime: boolean;

      phases: {};
    };

    liveState?: {
      phase: string;

      seconds: number;

      ongoing: boolean;

      toggleDate: string;
    };

    drawId?: number;

    timer?: {};

    managers?: Array<{
      user: {
        _id: string;

        name: string;
      };

      type: {
        label: string;

        value: string;
      };

      grant?: boolean;
    }>;
  }> {
    let path =
      '/match-manager/competitions/{competitionId}/parts/{partId}/matches/{matchId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#matchManagerGetMatchSuitableTeams
   */
  matchManagerGetMatchSuitableTeams(
    matchId: string,
    parameters: {
      limit?: number;
      offset?: number;
    } = {},
  ): Promise<{
    limit: number;

    offset: number;

    total: number;

    nextOffset?: number;

    teams: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;
  }> {
    let path = '/match-manager/matches/{matchId}/suitable-teams';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    queryParameters['limit'] = 100;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#matchManagerGetMatchNominations
   */
  matchManagerGetMatchNominations(
    competitionId: string,
    partId: string,
    matchId: string,
    teamId: string,
    parameters: {} = {},
  ): Promise<{
    teamId?: string;

    athletes: Array<{
      sportnetUser: {
        _id: string;

        name: string;
      };

      additionalData?: {};
    }>;

    crew?: Array<{
      sportnetUser: {
        _id: string | null;

        name: string | null;
      };

      position: string;
    }>;

    closed?: boolean;
  }> {
    let path =
      '/match-manager/competitions/{competitionId}/parts/{partId}/matches/{matchId}/nominations/{teamId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{matchId}', matchId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#matchManagerPutMatchNominations
   */
  matchManagerPutMatchNominations(
    competitionId: string,
    partId: string,
    matchId: string,
    teamId: string,
    parameters: {} = {},
    body: {
      teamId?: string;

      athletes: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;

      crew?: Array<{
        sportnetUser: {
          _id: string | null;

          name: string | null;
        };

        position: string;
      }>;

      closed?: boolean;
    },
  ): Promise<{}> {
    let path =
      '/match-manager/competitions/{competitionId}/parts/{partId}/matches/{matchId}/nominations/{teamId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{matchId}', matchId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#matchManagerGetOrganizationSportExperts
   */
  matchManagerGetOrganizationSportExperts(
    competitionId: string,
    partId: string,
    teamId: string,
    parameters: {} = {},
  ): Promise<{
    sportExperts?: Array<{
      sportnetId: string;

      displayName: string;

      birthyear?: string;
    }>;
  }> {
    let path =
      '/match-manager/competitions/{competitionId}/parts/{partId}/teams/{teamId}/sport-experts';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   * Get Contentspace Details
   * @method
   * @name Api#publicGetSettings
   */
  publicGetSettings(
    appSpace: string,
    parameters: {} = {},
  ): Promise<{
    domain?: string;

    homepageSectionIdOrUniqId?: string;
  }> {
    let path = '/public/{appSpace}/settings';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getCompetitions
   */
  getCompetitions(
    appSpace: string,
    parameters: {
      limit?: number;
      offset?: number;
      seasonId?: string;
      q?: string;
    } = {},
  ): Promise<{
    limit: number;

    offset: number;

    total: number;

    nextOffset?: number;

    competitions: Array<{
      _id?: string;

      competitionGroupId?: string;

      appSpace?: string;

      name?: string;

      season?: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      publication?: {};
    }>;
  }> {
    let path = '/public/{appSpace}/competitions';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    queryParameters['limit'] = 100;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    if (typeof parameters['seasonId'] !== 'undefined') {
      queryParameters['seasonId'] = parameters['seasonId'];
    }

    queryParameters['seasonId'] = this.transformParameter(
      queryParameters['seasonId'],
    );

    if (typeof parameters['q'] !== 'undefined') {
      queryParameters['q'] = parameters['q'];
    }

    queryParameters['q'] = this.transformParameter(queryParameters['q']);

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getCompetitionGroupById
   */
  getCompetitionGroupById(
    appSpace: string,
    competitionGroupId: string,
    parameters: {} = {},
  ): Promise<{
    _id?: string;

    competitions: Array<{
      _id: string;

      __issfId?: number;

      appSpace: string;

      name: string;

      competitionGroupId: string;

      season: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };
    }>;
  }> {
    let path = '/public/{appSpace}/competition-groups/{competitionGroupId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionGroupId}', competitionGroupId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getCompetitionById
   */
  getCompetitionById(
    appSpace: string,
    competitionId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    __issfId?: number;

    competitionGroupId: string;

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    smarttags?: Array<{
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    }>;

    homepageSectionIdOrUniqId?: string;

    appSpace: string;

    ownerPPO?: string;

    name: string;

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    teams?: Array<{
      _id: string;

      appSpace: string;

      name: string;

      displayName: string;

      organization: {
        _id: string;

        name: string;

        organization_id: string;

        organization_name: string;
      };
    }>;

    publication?: {};
  }> {
    let path = '/public/{appSpace}/competitions/{competitionId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getCompetitionParts
   */
  getCompetitionParts(
    appSpace: string,
    competitionId: string,
    parameters: {} = {},
  ): Promise<{
    parts: Array<{
      _id: string;

      __issfId?: string;

      name: string;

      publicComment?: string;

      dateFrom: string;

      dateTo: string;

      format?: string;

      rounds?: Array<{
        _id: string;

        name: string;

        dateFrom: string;

        dateTo: string;
      }>;
    }>;
  }> {
    let path = '/public/{appSpace}/competitions/{competitionId}/parts';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getCompetitionPartById
   */
  getCompetitionPartById(
    appSpace: string,
    competitionId: string,
    partId: string,
    parameters: {
      roundId?: string;
      omitResultsTable?: boolean;
    } = {},
  ): Promise<{
    _id: string;

    name: string;

    settings?: {};

    rounds?: Array<{
      _id: string;

      name: string;

      dateFrom: string;

      dateTo: string;
    }>;

    dateFrom: string;

    dateTo: string;
  }> {
    let path = '/public/{appSpace}/competitions/{competitionId}/parts/{partId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    if (typeof parameters['roundId'] !== 'undefined') {
      queryParameters['roundId'] = parameters['roundId'];
    }

    queryParameters['roundId'] = this.transformParameter(
      queryParameters['roundId'],
    );

    if (typeof parameters['omitResultsTable'] !== 'undefined') {
      queryParameters['omitResultsTable'] = parameters['omitResultsTable'];
    }

    queryParameters['omitResultsTable'] = this.transformParameter(
      queryParameters['omitResultsTable'],
    );

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getCompetitionPartMatches
   */
  getCompetitionPartMatches(
    appSpace: string,
    competitionId: string,
    partId: string,
    parameters: {
      limit?: number;
      offset?: number;
      roundId?: string;
      dateBefore?: string;
      dateAfter?: string;
      closed?: boolean;
    } = {},
  ): Promise<{
    limit: number;

    offset: number;

    total: number;

    nextOffset?: number;

    matches: Array<{
      _id: string;

      __issfId?: number;

      appSpace: string;

      drawId?: number;

      teams?: Array<{
        _id: string;

        appSpace: string;

        logo?: {
          media_url: string;

          public_url: string;
        };

        smarttags?: Array<{
          key: string | number;

          values: Array<{
            key: string | number;

            title?: string | null;
          }>;
        }>;

        name: string;

        displayName: string;

        gender?: string;

        sport_sector: string;

        athletes?: Array<{
          sportnetUser: {
            _id: string;

            name: string;
          };

          additionalData?: {};
        }>;
      }>;

      startDate: string;

      sportGround: {
        _id: string;

        name: string;

        sportGroundType: string;

        additionalData?: {};
      };

      settings?: {
        players: {
          field: {
            min: number;

            max: number;
          };

          substitutes: {
            max: number;
          };
        };

        contumation: {
          score: number;
        };

        reverseTime: boolean;

        overlapTime: boolean;

        phases: {};
      };

      competition: {
        _id: string;

        name: string;

        competitionGroupId: string;
      };

      competitionPart: {
        _id: string;

        name: string;
      };

      season: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      round?: {
        _id: string;

        name: string;

        dateFrom?: string;

        dateTo?: string;
      };

      closed?: boolean;

      rules?: {};

      contumation?: {
        isContumated: boolean;

        advantage: null | string;

        keepScore: boolean;
      };

      protocol?: {};

      liveState?: {
        ongoing: boolean;

        seconds: number;

        phase: string;

        toggleDate: string;
      };

      timer?: {};
    }>;
  }> {
    let path =
      '/public/{appSpace}/competitions/{competitionId}/parts/{partId}/matches';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    queryParameters['limit'] = 100;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    if (typeof parameters['roundId'] !== 'undefined') {
      queryParameters['roundId'] = parameters['roundId'];
    }

    queryParameters['roundId'] = this.transformParameter(
      queryParameters['roundId'],
    );

    if (typeof parameters['dateBefore'] !== 'undefined') {
      queryParameters['dateBefore'] = parameters['dateBefore'];
    }

    queryParameters['dateBefore'] = this.transformParameter(
      queryParameters['dateBefore'],
    );

    if (typeof parameters['dateAfter'] !== 'undefined') {
      queryParameters['dateAfter'] = parameters['dateAfter'];
    }

    queryParameters['dateAfter'] = this.transformParameter(
      queryParameters['dateAfter'],
    );

    if (typeof parameters['closed'] !== 'undefined') {
      queryParameters['closed'] = parameters['closed'];
    }

    queryParameters['closed'] = this.transformParameter(
      queryParameters['closed'],
    );

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getCompetitionMatches
   */
  getCompetitionMatches(
    appSpace: string,
    competitionId: string,
    parameters: {
      limit?: number;
      offset?: number;
      closed?: boolean;
      dateBefore?: string;
      dateAfter?: string;
    } = {},
  ): Promise<{
    limit: number;

    offset: number;

    total: number;

    nextOffset?: number;

    matches: Array<{
      _id: string;

      __issfId?: number;

      appSpace: string;

      drawId?: number;

      teams?: Array<{
        _id: string;

        appSpace: string;

        logo?: {
          media_url: string;

          public_url: string;
        };

        smarttags?: Array<{
          key: string | number;

          values: Array<{
            key: string | number;

            title?: string | null;
          }>;
        }>;

        name: string;

        displayName: string;

        gender?: string;

        sport_sector: string;

        athletes?: Array<{
          sportnetUser: {
            _id: string;

            name: string;
          };

          additionalData?: {};
        }>;
      }>;

      startDate: string;

      sportGround: {
        _id: string;

        name: string;

        sportGroundType: string;

        additionalData?: {};
      };

      settings?: {
        players: {
          field: {
            min: number;

            max: number;
          };

          substitutes: {
            max: number;
          };
        };

        contumation: {
          score: number;
        };

        reverseTime: boolean;

        overlapTime: boolean;

        phases: {};
      };

      competition: {
        _id: string;

        name: string;

        competitionGroupId: string;
      };

      competitionPart: {
        _id: string;

        name: string;
      };

      season: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      round?: {
        _id: string;

        name: string;

        dateFrom?: string;

        dateTo?: string;
      };

      closed?: boolean;

      rules?: {};

      contumation?: {
        isContumated: boolean;

        advantage: null | string;

        keepScore: boolean;
      };

      protocol?: {};

      liveState?: {
        ongoing: boolean;

        seconds: number;

        phase: string;

        toggleDate: string;
      };

      timer?: {};
    }>;
  }> {
    let path = '/public/{appSpace}/competitions/{competitionId}/matches';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    queryParameters['limit'] = 100;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    if (typeof parameters['closed'] !== 'undefined') {
      queryParameters['closed'] = parameters['closed'];
    }

    queryParameters['closed'] = this.transformParameter(
      queryParameters['closed'],
    );

    if (typeof parameters['dateBefore'] !== 'undefined') {
      queryParameters['dateBefore'] = parameters['dateBefore'];
    }

    queryParameters['dateBefore'] = this.transformParameter(
      queryParameters['dateBefore'],
    );

    if (typeof parameters['dateAfter'] !== 'undefined') {
      queryParameters['dateAfter'] = parameters['dateAfter'];
    }

    queryParameters['dateAfter'] = this.transformParameter(
      queryParameters['dateAfter'],
    );

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getPublicCompetitionPartCurrentResultTable
   */
  getPublicCompetitionPartCurrentResultTable(
    competitionId: string,
    partId: string,
    parameters: {
      roundId?: string;
    } = {},
  ): Promise<{
    results: Array<{
      team: {
        _id: string;

        name: string;

        displayName: string;

        resignation?: boolean;
      };

      stats: {
        matches: {
          played: number;

          won: number;

          draw: number;

          lost: number;
        };

        goals: {
          given: number;

          received: number;
        };

        points: number;
      };

      homeStats?: {
        matches: {
          played: number;

          won: number;

          draw: number;

          lost: number;
        };

        goals: {
          given: number;

          received: number;
        };

        points: number;
      };

      awayStats?: {
        matches: {
          played: number;

          won: number;

          draw: number;

          lost: number;
        };

        goals: {
          given: number;

          received: number;
        };

        points: number;
      };

      matches?: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;
        };

        result: 'W' | 'L' | 'D';

        homeaway: 'home' | 'away';

        matchId: string;

        score: string;
      }>;

      homeMatches?: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;
        };

        result: 'W' | 'L' | 'D';

        homeaway: 'home' | 'away';

        matchId: string;

        score: string;
      }>;

      awayMatches?: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;
        };

        result: 'W' | 'L' | 'D';

        homeaway: 'home' | 'away';

        matchId: string;

        score: string;
      }>;
    }>;
  }> {
    let path = '/public/competitions/{competitionId}/parts/{partId}/results';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    if (typeof parameters['roundId'] !== 'undefined') {
      queryParameters['roundId'] = parameters['roundId'];
    }

    queryParameters['roundId'] = this.transformParameter(
      queryParameters['roundId'],
    );

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getPublicCompetitionPartCurrentPlayersStats
   */
  getPublicCompetitionPartCurrentPlayersStats(
    competitionId: string,
    partId: string,
    parameters: {
      roundId?: string;
    } = {},
  ): Promise<{
    players: Array<{
      match_starts?: number;

      match_appearances?: number;

      goals?: number;

      assists?: number;

      yellow_cards?: number;

      red_cards?: number;

      substitutions?: number;

      own_goals?: number;
    }>;
  }> {
    let path = '/public/competitions/{competitionId}/parts/{partId}/players';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    if (typeof parameters['roundId'] !== 'undefined') {
      queryParameters['roundId'] = parameters['roundId'];
    }

    queryParameters['roundId'] = this.transformParameter(
      queryParameters['roundId'],
    );

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getMatchResultsTable
   */
  getMatchResultsTable(
    matchId: string,
    parameters: {} = {},
  ): Promise<{
    results: Array<{
      team: {
        _id: string;

        name: string;

        displayName: string;

        resignation?: boolean;
      };

      stats: {
        matches: {
          played: number;

          won: number;

          draw: number;

          lost: number;
        };

        goals: {
          given: number;

          received: number;
        };

        points: number;
      };

      homeStats?: {
        matches: {
          played: number;

          won: number;

          draw: number;

          lost: number;
        };

        goals: {
          given: number;

          received: number;
        };

        points: number;
      };

      awayStats?: {
        matches: {
          played: number;

          won: number;

          draw: number;

          lost: number;
        };

        goals: {
          given: number;

          received: number;
        };

        points: number;
      };

      matches?: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;
        };

        result: 'W' | 'L' | 'D';

        homeaway: 'home' | 'away';

        matchId: string;

        score: string;
      }>;

      homeMatches?: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;
        };

        result: 'W' | 'L' | 'D';

        homeaway: 'home' | 'away';

        matchId: string;

        score: string;
      }>;

      awayMatches?: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;
        };

        result: 'W' | 'L' | 'D';

        homeaway: 'home' | 'away';

        matchId: string;

        score: string;
      }>;
    }>;
  }> {
    let path = '/matches/{matchId}/results';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getPlayerStats
   */
  getPlayerStats(
    appSpace: string,
    sportnetId: string,
    parameters: {
      seasonId?: string;
      competitionGroupId?: string;
    } = {},
  ): Promise<{
    summary: {
      stats: {
        match_starts?: number;

        match_appearances?: number;

        goals?: number;

        assists?: number;

        yellow_cards?: number;

        red_cards?: number;

        substitutions?: number;

        own_goals?: number;
      };
    };

    byCompetition: Array<{
      _id: string;

      name: string;

      stats: {
        match_starts?: number;

        match_appearances?: number;

        goals?: number;

        assists?: number;

        yellow_cards?: number;

        red_cards?: number;

        substitutions?: number;

        own_goals?: number;
      };
    }>;
  }> {
    let path = '/public/{appSpace}/players/{sportnetId}/stats';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    if (typeof parameters['seasonId'] !== 'undefined') {
      queryParameters['seasonId'] = parameters['seasonId'];
    }

    queryParameters['seasonId'] = this.transformParameter(
      queryParameters['seasonId'],
    );

    if (typeof parameters['competitionGroupId'] !== 'undefined') {
      queryParameters['competitionGroupId'] = parameters['competitionGroupId'];
    }

    queryParameters['competitionGroupId'] = this.transformParameter(
      queryParameters['competitionGroupId'],
    );

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{sportnetId}', sportnetId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getAllTeams
   */
  getAllTeams(
    parameters: {
      q?: string;
      seasonIds?: Array<string>;
    } = {},
  ): Promise<{
    teams: Array<{
      _id: string;

      appSpace: string;

      name: string;

      displayName: string;

      gender: string;

      sport_sector: string;
    }>;
  }> {
    let path = '/teams';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    if (typeof parameters['q'] !== 'undefined') {
      queryParameters['q'] = parameters['q'];
    }

    queryParameters['q'] = this.transformParameter(queryParameters['q']);

    if (typeof parameters['seasonIds'] !== 'undefined') {
      queryParameters['season_ids'] = parameters['seasonIds'];
    }

    queryParameters['season_ids'] = this.transformParameter(
      queryParameters['season_ids'],
    );

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getTeams
   */
  getTeams(
    appSpace: string,
    parameters: {
      limit?: number;
      offset?: number;
      seasonIds?: Array<string>;
    } = {},
  ): Promise<{
    limit: number;

    offset: number;

    total: number;

    nextOffset?: number;

    teams: Array<{
      _id: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      appSpace: string;

      name: string;

      displayName: string;

      gender: string;

      sport_sector: string;
    }>;
  }> {
    let path = '/public/{appSpace}/teams';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    queryParameters['limit'] = 100;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    if (typeof parameters['seasonIds'] !== 'undefined') {
      queryParameters['season_ids'] = parameters['seasonIds'];
    }

    queryParameters['season_ids'] = this.transformParameter(
      queryParameters['season_ids'],
    );

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getTeam
   */
  getTeam(
    appSpace: string,
    teamId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    appSpace: string;

    logo?: {
      media_url: string;

      public_url: string;
    };

    smarttags?: Array<{
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    }>;

    name: string;

    displayName: string;

    gender?: string;

    sport_sector: string;
  }> {
    let path = '/public/{appSpace}/teams/{teamId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getTeamCompetitions
   */
  getTeamCompetitions(
    appSpace: string,
    teamId: string,
    parameters: {
      seasonId?: string;
    } = {},
  ): Promise<{
    competitions: Array<{
      _id?: string;

      competitionGroupId?: string;

      appSpace?: string;

      name?: string;

      season?: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      publication?: {};
    }>;
  }> {
    let path = '/public/{appSpace}/teams/{teamId}/competitions';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    if (typeof parameters['seasonId'] !== 'undefined') {
      queryParameters['seasonId'] = parameters['seasonId'];
    }

    queryParameters['seasonId'] = this.transformParameter(
      queryParameters['seasonId'],
    );

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getTeamCompetition
   */
  getTeamCompetition(
    appSpace: string,
    teamId: string,
    competitionId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    competitionGroupId: string;

    appSpace: string;

    name: string;

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    publication?: {};

    players: Array<{
      sportnetUser: {
        _id: string;

        name: string;
      };

      additionalData?: {};
    }>;

    matches: Array<{
      _id: string;

      __issfId?: number;

      appSpace: string;

      drawId?: number;

      teams?: Array<{
        _id: string;

        appSpace: string;

        logo?: {
          media_url: string;

          public_url: string;
        };

        smarttags?: Array<{
          key: string | number;

          values: Array<{
            key: string | number;

            title?: string | null;
          }>;
        }>;

        name: string;

        displayName: string;

        gender?: string;

        sport_sector: string;

        athletes?: Array<{
          sportnetUser: {
            _id: string;

            name: string;
          };

          additionalData?: {};
        }>;
      }>;

      startDate: string;

      sportGround: {
        _id: string;

        name: string;

        sportGroundType: string;

        additionalData?: {};
      };

      settings?: {
        players: {
          field: {
            min: number;

            max: number;
          };

          substitutes: {
            max: number;
          };
        };

        contumation: {
          score: number;
        };

        reverseTime: boolean;

        overlapTime: boolean;

        phases: {};
      };

      competition: {
        _id: string;

        name: string;

        competitionGroupId: string;
      };

      competitionPart: {
        _id: string;

        name: string;
      };

      season: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      round?: {
        _id: string;

        name: string;

        dateFrom?: string;

        dateTo?: string;
      };

      closed?: boolean;

      rules?: {};

      contumation?: {
        isContumated: boolean;

        advantage: null | string;

        keepScore: boolean;
      };

      protocol?: {};

      liveState?: {
        ongoing: boolean;

        seconds: number;

        phase: string;

        toggleDate: string;
      };

      timer?: {};
    }>;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };
  }> {
    let path = '/public/{appSpace}/teams/{teamId}/competitions/{competitionId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{teamId}', teamId.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getTeamCompetitionMatches
   */
  getTeamCompetitionMatches(
    appSpace: string,
    teamIds: Array<string>,
    competitionId: string,
    parameters: {
      limit?: number;
      offset?: number;
      closed?: boolean;
      dateBefore?: string;
      dateAfter?: string;
    } = {},
  ): Promise<{
    limit: number;

    offset: number;

    total: number;

    nextOffset?: number;

    matches: Array<{
      _id: string;

      __issfId?: number;

      appSpace: string;

      drawId?: number;

      teams?: Array<{
        _id: string;

        appSpace: string;

        logo?: {
          media_url: string;

          public_url: string;
        };

        smarttags?: Array<{
          key: string | number;

          values: Array<{
            key: string | number;

            title?: string | null;
          }>;
        }>;

        name: string;

        displayName: string;

        gender?: string;

        sport_sector: string;

        athletes?: Array<{
          sportnetUser: {
            _id: string;

            name: string;
          };

          additionalData?: {};
        }>;
      }>;

      startDate: string;

      sportGround: {
        _id: string;

        name: string;

        sportGroundType: string;

        additionalData?: {};
      };

      settings?: {
        players: {
          field: {
            min: number;

            max: number;
          };

          substitutes: {
            max: number;
          };
        };

        contumation: {
          score: number;
        };

        reverseTime: boolean;

        overlapTime: boolean;

        phases: {};
      };

      competition: {
        _id: string;

        name: string;

        competitionGroupId: string;
      };

      competitionPart: {
        _id: string;

        name: string;
      };

      season: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      round?: {
        _id: string;

        name: string;

        dateFrom?: string;

        dateTo?: string;
      };

      closed?: boolean;

      rules?: {};

      contumation?: {
        isContumated: boolean;

        advantage: null | string;

        keepScore: boolean;
      };

      protocol?: {};

      liveState?: {
        ongoing: boolean;

        seconds: number;

        phase: string;

        toggleDate: string;
      };

      timer?: {};
    }>;
  }> {
    let path =
      '/public/{appSpace}/teams/{teamIds}/competitions/{competitionId}/matches';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{teamIds}', teamIds.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    queryParameters['limit'] = 100;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    if (typeof parameters['closed'] !== 'undefined') {
      queryParameters['closed'] = parameters['closed'];
    }

    queryParameters['closed'] = this.transformParameter(
      queryParameters['closed'],
    );

    if (typeof parameters['dateBefore'] !== 'undefined') {
      queryParameters['dateBefore'] = parameters['dateBefore'];
    }

    queryParameters['dateBefore'] = this.transformParameter(
      queryParameters['dateBefore'],
    );

    if (typeof parameters['dateAfter'] !== 'undefined') {
      queryParameters['dateAfter'] = parameters['dateAfter'];
    }

    queryParameters['dateAfter'] = this.transformParameter(
      queryParameters['dateAfter'],
    );

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getSeasons
   */
  getSeasons(
    appSpace: string,
    parameters: {} = {},
  ): Promise<{
    seasons: Array<{
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    }>;
  }> {
    let path = '/public/{appSpace}/seasons';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getClubPlayedSeasons
   */
  getClubPlayedSeasons(
    appSpace: string,
    parameters: {
      playerId?: string;
    } = {},
  ): Promise<{
    seasons: Array<{
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    }>;
  }> {
    let path = '/public/{appSpace}/played-seasons';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    if (typeof parameters['playerId'] !== 'undefined') {
      queryParameters['playerId'] = parameters['playerId'];
    }

    queryParameters['playerId'] = this.transformParameter(
      queryParameters['playerId'],
    );

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getMatch
   */
  getMatch(
    matchId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    appSpace: string;

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;

    startDate: string;

    sportGround: {
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    };

    competition: {
      _id: string;

      name: string;

      competitionGroupId: string;
    };

    competitionPart: {
      _id: string;

      name: string;
    };

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    round?: {
      _id?: string;

      name: string;

      dateFrom?: string;

      dateTo?: string;
    };

    nominations: Array<{
      teamId?: string;

      athletes: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;

      crew?: Array<{
        sportnetUser: {
          _id: string | null;

          name: string | null;
        };

        position: string;
      }>;

      closed?: boolean;
    }>;

    protocol?: {
      events?: Array<{}>;
    };

    rules?: {
      gender?: string;

      sport_sector?: string;

      discipline?: string;
    };

    closed?: boolean;

    contumation?: {
      isContumated: boolean;

      advantage: null | string;

      keepScore: boolean;
    };

    __issfId?: number;

    score?: Array<number>;

    livestream?: string;

    ticketsUrl?: string;

    settings: {
      players: {
        field: {
          min: number;

          max: number;
        };

        substitutes: {
          max: number;
        };
      };

      contumation: {
        score: number;
      };

      reverseTime: boolean;

      overlapTime: boolean;

      phases: {};
    };

    liveState?: {
      phase: string;

      seconds: number;

      ongoing: boolean;

      toggleDate: string;
    };

    drawId?: number;

    timer?: {};

    managers?: Array<{
      user: {
        _id: string;

        name: string;
      };

      type: {
        label: string;

        value: string;
      };

      grant?: boolean;
    }>;
  }> {
    let path = '/matches/{matchId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getRecordsBySport
   */
  getRecordsBySport(
    sport: string,
    parameters: {
      gender?: string;
      ageCategoryId?: string;
      disciplineName?: string;
      disciplineParameters?: Array<string>;
    } = {},
  ): Promise<{
    items: Array<{
      _id: string;

      gender: string;

      sport: string;

      records: Array<{
        place: string;

        date: string;

        record: {
          type: string;

          value: string;
        };

        holders: Array<{
          _id: string;

          name: string;
        }>;

        club: {
          _id: string;

          name: string;
        };
      }>;

      ageCategory: {
        _id: string;

        name: string;
      };

      discipline: {
        _id: string;

        name: string;

        parameters: Array<{
          _id: string;

          name: string;

          value: string;
        }>;
      };
    }>;
  }> {
    let path = '/records/{sport}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    if (typeof parameters['gender'] !== 'undefined') {
      queryParameters['gender'] = parameters['gender'];
    }

    queryParameters['gender'] = this.transformParameter(
      queryParameters['gender'],
    );

    if (typeof parameters['ageCategoryId'] !== 'undefined') {
      queryParameters['ageCategoryId'] = parameters['ageCategoryId'];
    }

    queryParameters['ageCategoryId'] = this.transformParameter(
      queryParameters['ageCategoryId'],
    );

    if (typeof parameters['disciplineName'] !== 'undefined') {
      queryParameters['disciplineName'] = parameters['disciplineName'];
    }

    queryParameters['disciplineName'] = this.transformParameter(
      queryParameters['disciplineName'],
    );

    if (typeof parameters['disciplineParameters'] !== 'undefined') {
      queryParameters['disciplineParameters'] =
        parameters['disciplineParameters'];
    }

    queryParameters['disciplineParameters'] = this.transformParameter(
      queryParameters['disciplineParameters'],
    );

    path = path.replace('{sport}', sport.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getSettingById
   */
  getSettingById(settingId: string, parameters: {} = {}): Promise<{}> {
    let path = '/settings/{settingId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{settingId}', settingId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getSettingBySportSector
   */
  getSettingBySportSector(
    settingId: string,
    sectorId: string,
    parameters: {} = {},
  ): Promise<{
    items: Array<{
      _id: string;

      label: string;
    }>;
  }> {
    let path = '/settings/{settingId}/sector/{sectorId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{settingId}', settingId.toString());

    path = path.replace('{sectorId}', sectorId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getAllCompetitionGroups
   */
  getAllCompetitionGroups(
    parameters: {
      appSpaces?: Array<string>;
    } = {},
  ): Promise<{
    items: Array<{
      _id: string;

      name: string;

      appSpace: string;
    }>;
  }> {
    let path = '/competition-groups';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    if (typeof parameters['appSpaces'] !== 'undefined') {
      queryParameters['appSpaces'] = parameters['appSpaces'];
    }

    queryParameters['appSpaces'] = this.transformParameter(
      queryParameters['appSpaces'],
    );

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getAllCompetitions
   */
  getAllCompetitions(
    parameters: {
      q?: string;
      appSpace?: string;
      ownerPpo?: string;
      format?: string;
      type?: string;
      seasonName?: string;
    } = {},
  ): Promise<{
    competitions: Array<{
      _id: string;

      __issfId?: number;

      organization_name?: string;

      competitionGroupId: string;

      sortvalue?: number;

      level?: number;

      appSpace: string;

      sport: string;

      name: string;

      season: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      parts?: Array<{
        _id: string;

        name: string;

        rules?: {
          sport_sector?: string;

          gender?: string;

          category?: string;
        };

        rounds?: Array<{
          _id: string;

          name: string;
        }>;
      }>;
    }>;
  }> {
    let path = '/competitions';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    if (typeof parameters['q'] !== 'undefined') {
      queryParameters['q'] = parameters['q'];
    }

    queryParameters['q'] = this.transformParameter(queryParameters['q']);

    if (typeof parameters['appSpace'] !== 'undefined') {
      queryParameters['appSpace'] = parameters['appSpace'];
    }

    queryParameters['appSpace'] = this.transformParameter(
      queryParameters['appSpace'],
    );

    if (typeof parameters['ownerPpo'] !== 'undefined') {
      queryParameters['ownerPPO'] = parameters['ownerPpo'];
    }

    queryParameters['ownerPPO'] = this.transformParameter(
      queryParameters['ownerPPO'],
    );

    if (typeof parameters['format'] !== 'undefined') {
      queryParameters['format'] = parameters['format'];
    }

    queryParameters['format'] = this.transformParameter(
      queryParameters['format'],
    );

    if (typeof parameters['type'] !== 'undefined') {
      queryParameters['type'] = parameters['type'];
    }

    queryParameters['type'] = this.transformParameter(queryParameters['type']);

    if (typeof parameters['seasonName'] !== 'undefined') {
      queryParameters['seasonName'] = parameters['seasonName'];
    }

    queryParameters['seasonName'] = this.transformParameter(
      queryParameters['seasonName'],
    );

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getPublicCompetitionPartById
   */
  getPublicCompetitionPartById(
    competitionId: string,
    partId: string,
    parameters: {
      roundId?: string;
    } = {},
  ): Promise<{
    _id: string;

    name: string;

    rounds?: Array<{
      _id: string;

      name: string;

      dateFrom: string;

      dateTo: string;
    }>;

    dateFrom: string;

    dateTo: string;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };
  }> {
    let path = '/competitions/{competitionId}/parts/{partId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    if (typeof parameters['roundId'] !== 'undefined') {
      queryParameters['roundId'] = parameters['roundId'];
    }

    queryParameters['roundId'] = this.transformParameter(
      queryParameters['roundId'],
    );

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getMatches
   */
  getMatches(
    parameters: {
      playerAppSpace?: string;
      playerId?: string;
      competitionGroupId?: string;
      competitionId?: string;
      partId?: string;
      roundId?: string;
      dateFrom?: string;
      dateTo?: string;
      closed?: boolean;
      teamId?: string;
      seasonName?: string;
      ids?: Array<string>;
      excludeIds?: Array<string>;
      teamAppSpaces?: Array<string>;
      allTeamIds?: Array<string>;
      appSpace?: string;
      offset?: number;
      limit?: number;
    } = {},
  ): Promise<{
    nextOffset?: number | null;

    total?: number;

    matches: Array<{
      _id: string;

      __issfId?: number;

      score?: Array<number>;

      drawId?: number;

      rules: {
        sport_sector: string;
      };

      appSpace: string;

      timer?: {};

      protocol?: {
        events?: Array<{}>;
      };

      teams: Array<{
        _id: string;

        appSpace: string;

        name: string;

        displayName: string;

        gender?: string;

        sport_sector: string;

        additionalProperties?: {
          homeaway?: 'home' | 'away';
        };
      }>;

      startDate: string;

      sportGround: {
        _id: string;

        sportObjectName: string;
      };

      competition: {
        _id: string;

        name: string;

        competitionGroupId: string;
      };

      competitionPart: {
        _id: string;

        name: string;
      };

      season: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      settings?: {
        contumation: {
          score: number;
        };

        reverseTime: boolean;

        overlapTime: boolean;

        phases: {};

        players: {
          field: {
            min: number;

            max: number;
          };

          substitutes: {
            max: number;
          };
        };
      };

      round?: {
        _id: string;

        name: string;

        dateFrom?: string;

        dateTo?: string;
      };

      closed?: boolean;

      contumation?: {
        isContumated?: boolean;

        keepScore?: boolean;

        advantage?: string;
      };
    }>;
  }> {
    let path = '/matches';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    if (typeof parameters['playerAppSpace'] !== 'undefined') {
      queryParameters['playerAppSpace'] = parameters['playerAppSpace'];
    }

    queryParameters['playerAppSpace'] = this.transformParameter(
      queryParameters['playerAppSpace'],
    );

    if (typeof parameters['playerId'] !== 'undefined') {
      queryParameters['playerId'] = parameters['playerId'];
    }

    queryParameters['playerId'] = this.transformParameter(
      queryParameters['playerId'],
    );

    if (typeof parameters['competitionGroupId'] !== 'undefined') {
      queryParameters['competitionGroupId'] = parameters['competitionGroupId'];
    }

    queryParameters['competitionGroupId'] = this.transformParameter(
      queryParameters['competitionGroupId'],
    );

    if (typeof parameters['competitionId'] !== 'undefined') {
      queryParameters['competitionId'] = parameters['competitionId'];
    }

    queryParameters['competitionId'] = this.transformParameter(
      queryParameters['competitionId'],
    );

    if (typeof parameters['partId'] !== 'undefined') {
      queryParameters['partId'] = parameters['partId'];
    }

    queryParameters['partId'] = this.transformParameter(
      queryParameters['partId'],
    );

    if (typeof parameters['roundId'] !== 'undefined') {
      queryParameters['roundId'] = parameters['roundId'];
    }

    queryParameters['roundId'] = this.transformParameter(
      queryParameters['roundId'],
    );

    if (typeof parameters['dateFrom'] !== 'undefined') {
      queryParameters['dateFrom'] = parameters['dateFrom'];
    }

    queryParameters['dateFrom'] = this.transformParameter(
      queryParameters['dateFrom'],
    );

    if (typeof parameters['dateTo'] !== 'undefined') {
      queryParameters['dateTo'] = parameters['dateTo'];
    }

    queryParameters['dateTo'] = this.transformParameter(
      queryParameters['dateTo'],
    );

    if (typeof parameters['closed'] !== 'undefined') {
      queryParameters['closed'] = parameters['closed'];
    }

    queryParameters['closed'] = this.transformParameter(
      queryParameters['closed'],
    );

    if (typeof parameters['teamId'] !== 'undefined') {
      queryParameters['teamId'] = parameters['teamId'];
    }

    queryParameters['teamId'] = this.transformParameter(
      queryParameters['teamId'],
    );

    if (typeof parameters['seasonName'] !== 'undefined') {
      queryParameters['seasonName'] = parameters['seasonName'];
    }

    queryParameters['seasonName'] = this.transformParameter(
      queryParameters['seasonName'],
    );

    if (typeof parameters['ids'] !== 'undefined') {
      queryParameters['ids'] = parameters['ids'];
    }

    queryParameters['ids'] = this.transformParameter(queryParameters['ids']);

    if (typeof parameters['excludeIds'] !== 'undefined') {
      queryParameters['excludeIds'] = parameters['excludeIds'];
    }

    queryParameters['excludeIds'] = this.transformParameter(
      queryParameters['excludeIds'],
      'joinUsingPipes',
    );

    if (typeof parameters['teamAppSpaces'] !== 'undefined') {
      queryParameters['teamAppSpaces'] = parameters['teamAppSpaces'];
    }

    queryParameters['teamAppSpaces'] = this.transformParameter(
      queryParameters['teamAppSpaces'],
      'joinUsingPipes',
    );

    if (typeof parameters['allTeamIds'] !== 'undefined') {
      queryParameters['allTeamIds'] = parameters['allTeamIds'];
    }

    queryParameters['allTeamIds'] = this.transformParameter(
      queryParameters['allTeamIds'],
      'joinUsingPipes',
    );

    if (typeof parameters['appSpace'] !== 'undefined') {
      queryParameters['appSpace'] = parameters['appSpace'];
    }

    queryParameters['appSpace'] = this.transformParameter(
      queryParameters['appSpace'],
    );

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    queryParameters['limit'] = 20;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getH2HMatches
   */
  getH2HMatches(
    parameters: {
      competitionGroupId?: string;
      dateFrom?: string;
      dateTo?: string;
      closed?: boolean;
      excludeIds?: Array<string>;
      teamAppSpaces?: Array<string>;
      limit?: number;
    } = {},
  ): Promise<{
    firstTeamMatches?: Array<{
      _id: string;

      __issfId?: number;

      score?: Array<number>;

      drawId?: number;

      rules: {
        sport_sector: string;
      };

      appSpace: string;

      timer?: {};

      protocol?: {
        events?: Array<{}>;
      };

      teams: Array<{
        _id: string;

        appSpace: string;

        name: string;

        displayName: string;

        gender?: string;

        sport_sector: string;

        additionalProperties?: {
          homeaway?: 'home' | 'away';
        };
      }>;

      startDate: string;

      sportGround: {
        _id: string;

        sportObjectName: string;
      };

      competition: {
        _id: string;

        name: string;

        competitionGroupId: string;
      };

      competitionPart: {
        _id: string;

        name: string;
      };

      season: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      settings?: {
        contumation: {
          score: number;
        };

        reverseTime: boolean;

        overlapTime: boolean;

        phases: {};

        players: {
          field: {
            min: number;

            max: number;
          };

          substitutes: {
            max: number;
          };
        };
      };

      round?: {
        _id: string;

        name: string;

        dateFrom?: string;

        dateTo?: string;
      };

      closed?: boolean;

      contumation?: {
        isContumated?: boolean;

        keepScore?: boolean;

        advantage?: string;
      };
    }>;

    secondTeamMatches?: Array<{
      _id: string;

      __issfId?: number;

      score?: Array<number>;

      drawId?: number;

      rules: {
        sport_sector: string;
      };

      appSpace: string;

      timer?: {};

      protocol?: {
        events?: Array<{}>;
      };

      teams: Array<{
        _id: string;

        appSpace: string;

        name: string;

        displayName: string;

        gender?: string;

        sport_sector: string;

        additionalProperties?: {
          homeaway?: 'home' | 'away';
        };
      }>;

      startDate: string;

      sportGround: {
        _id: string;

        sportObjectName: string;
      };

      competition: {
        _id: string;

        name: string;

        competitionGroupId: string;
      };

      competitionPart: {
        _id: string;

        name: string;
      };

      season: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      settings?: {
        contumation: {
          score: number;
        };

        reverseTime: boolean;

        overlapTime: boolean;

        phases: {};

        players: {
          field: {
            min: number;

            max: number;
          };

          substitutes: {
            max: number;
          };
        };
      };

      round?: {
        _id: string;

        name: string;

        dateFrom?: string;

        dateTo?: string;
      };

      closed?: boolean;

      contumation?: {
        isContumated?: boolean;

        keepScore?: boolean;

        advantage?: string;
      };
    }>;

    commonMatches?: Array<{
      _id: string;

      __issfId?: number;

      score?: Array<number>;

      drawId?: number;

      rules: {
        sport_sector: string;
      };

      appSpace: string;

      timer?: {};

      protocol?: {
        events?: Array<{}>;
      };

      teams: Array<{
        _id: string;

        appSpace: string;

        name: string;

        displayName: string;

        gender?: string;

        sport_sector: string;

        additionalProperties?: {
          homeaway?: 'home' | 'away';
        };
      }>;

      startDate: string;

      sportGround: {
        _id: string;

        sportObjectName: string;
      };

      competition: {
        _id: string;

        name: string;

        competitionGroupId: string;
      };

      competitionPart: {
        _id: string;

        name: string;
      };

      season: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      settings?: {
        contumation: {
          score: number;
        };

        reverseTime: boolean;

        overlapTime: boolean;

        phases: {};

        players: {
          field: {
            min: number;

            max: number;
          };

          substitutes: {
            max: number;
          };
        };
      };

      round?: {
        _id: string;

        name: string;

        dateFrom?: string;

        dateTo?: string;
      };

      closed?: boolean;

      contumation?: {
        isContumated?: boolean;

        keepScore?: boolean;

        advantage?: string;
      };
    }>;
  }> {
    let path = '/h2h-matches';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    if (typeof parameters['competitionGroupId'] !== 'undefined') {
      queryParameters['competitionGroupId'] = parameters['competitionGroupId'];
    }

    queryParameters['competitionGroupId'] = this.transformParameter(
      queryParameters['competitionGroupId'],
    );

    if (typeof parameters['dateFrom'] !== 'undefined') {
      queryParameters['dateFrom'] = parameters['dateFrom'];
    }

    queryParameters['dateFrom'] = this.transformParameter(
      queryParameters['dateFrom'],
    );

    if (typeof parameters['dateTo'] !== 'undefined') {
      queryParameters['dateTo'] = parameters['dateTo'];
    }

    queryParameters['dateTo'] = this.transformParameter(
      queryParameters['dateTo'],
    );

    if (typeof parameters['closed'] !== 'undefined') {
      queryParameters['closed'] = parameters['closed'];
    }

    queryParameters['closed'] = this.transformParameter(
      queryParameters['closed'],
    );

    if (typeof parameters['excludeIds'] !== 'undefined') {
      queryParameters['excludeIds'] = parameters['excludeIds'];
    }

    queryParameters['excludeIds'] = this.transformParameter(
      queryParameters['excludeIds'],
      'joinUsingPipes',
    );

    if (typeof parameters['teamAppSpaces'] !== 'undefined') {
      queryParameters['teamAppSpaces'] = parameters['teamAppSpaces'];
    }

    queryParameters['teamAppSpaces'] = this.transformParameter(
      queryParameters['teamAppSpaces'],
      'joinUsingPipes',
    );

    queryParameters['limit'] = 20;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getLastRoundMatches
   */
  getLastRoundMatches(
    competitionId: string,
    parameters: {
      offset?: number;
      limit?: number;
    } = {},
  ): Promise<{
    nextOffset?: number | null;

    total?: number;

    matches: Array<{
      _id: string;

      __issfId?: number;

      drawId?: number;

      rules: {
        sport_sector: string;
      };

      appSpace: string;

      timer?: {};

      protocol?: {
        events?: Array<{}>;
      };

      teams: Array<{
        _id: string;

        appSpace: string;

        name: string;

        displayName: string;

        gender?: string;

        sport_sector: string;

        additionalProperties?: {
          homeaway?: 'home' | 'away';
        };
      }>;

      startDate: string;

      sportGround: {
        _id: string;

        sportObjectName: string;
      };

      competition: {
        _id: string;

        name: string;

        competitionGroupId: string;
      };

      competitionPart: {
        _id: string;

        name: string;
      };

      season: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      settings?: {
        contumation: {
          score: number;
        };

        reverseTime: boolean;

        overlapTime: boolean;

        phases: {};

        players: {
          field: {
            min: number;

            max: number;
          };

          substitutes: {
            max: number;
          };
        };
      };

      round?: {
        _id: string;

        name: string;

        dateFrom?: string;

        dateTo?: string;
      };

      closed?: boolean;

      contumation?: {
        isContumated?: boolean;

        keepScore?: boolean;

        advantage?: string;
      };
    }>;
  }> {
    let path = '/public/competitions/{competitionId}/last-round-matches';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    path = path.replace('{competitionId}', competitionId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getH2HStats
   */
  getH2HStats(
    teamIds: Array<string>,
    parameters: {} = {},
  ): Promise<{
    results: Array<{
      team: {
        _id: string;

        name: string;

        displayName: string;

        resignation?: boolean;
      };

      stats: {
        matches: {
          played: number;

          won: number;

          draw: number;

          lost: number;
        };

        goals: {
          given: number;

          received: number;
        };

        points: number;
      };

      homeStats?: {
        matches: {
          played: number;

          won: number;

          draw: number;

          lost: number;
        };

        goals: {
          given: number;

          received: number;
        };

        points: number;
      };

      awayStats?: {
        matches: {
          played: number;

          won: number;

          draw: number;

          lost: number;
        };

        goals: {
          given: number;

          received: number;
        };

        points: number;
      };

      matches?: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;
        };

        result: 'W' | 'L' | 'D';

        homeaway: 'home' | 'away';

        matchId: string;

        score: string;
      }>;

      homeMatches?: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;
        };

        result: 'W' | 'L' | 'D';

        homeaway: 'home' | 'away';

        matchId: string;

        score: string;
      }>;

      awayMatches?: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;
        };

        result: 'W' | 'L' | 'D';

        homeaway: 'home' | 'away';

        matchId: string;

        score: string;
      }>;
    }>;
  }> {
    let path = '/public/h2h/{teamIds}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{teamIds}', teamIds.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getPlayerMatches
   */
  getPlayerMatches(
    appSpace: string,
    sportnetId: string,
    parameters: {
      limit?: number;
      offset?: number;
      competitionId?: string;
      partId?: string;
      roundId?: string;
      dateFrom?: string;
      dateTo?: string;
      closed?: boolean;
      teamId?: string;
      ids?: Array<string>;
    } = {},
  ): Promise<{
    limit: number;

    offset: number;

    total: number;

    nextOffset?: number;

    matches: Array<{
      _id: string;

      drawId?: number;

      rules: {
        sport_sector: string;
      };

      appSpace: string;

      timer?: {};

      protocol?: {
        events?: Array<{}>;
      };

      teams: Array<{
        _id: string;

        appSpace?: string;

        name: string;

        displayName?: string;

        gender?: string;

        sport_sector?: string;

        additionalProperties?: {
          homeaway?: 'home' | 'away';
        };
      }>;

      startDate: string;

      sportGround: {
        sportObjectName: string;
      };

      competition: {
        _id: string;

        name: string;
      };

      competitionPart: {
        _id: string;

        name: string;
      };

      season?: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      round?: {
        _id?: string;

        name: string;

        dateFrom?: string;

        dateTo?: string;
      };

      closed?: boolean;
    }>;
  }> {
    let path = '/player-matches/ppo/{appSpace}/player/{sportnetId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{sportnetId}', sportnetId.toString());

    queryParameters['limit'] = 100;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    if (typeof parameters['competitionId'] !== 'undefined') {
      queryParameters['competitionId'] = parameters['competitionId'];
    }

    queryParameters['competitionId'] = this.transformParameter(
      queryParameters['competitionId'],
    );

    if (typeof parameters['partId'] !== 'undefined') {
      queryParameters['partId'] = parameters['partId'];
    }

    queryParameters['partId'] = this.transformParameter(
      queryParameters['partId'],
    );

    if (typeof parameters['roundId'] !== 'undefined') {
      queryParameters['roundId'] = parameters['roundId'];
    }

    queryParameters['roundId'] = this.transformParameter(
      queryParameters['roundId'],
    );

    if (typeof parameters['dateFrom'] !== 'undefined') {
      queryParameters['dateFrom'] = parameters['dateFrom'];
    }

    queryParameters['dateFrom'] = this.transformParameter(
      queryParameters['dateFrom'],
    );

    if (typeof parameters['dateTo'] !== 'undefined') {
      queryParameters['dateTo'] = parameters['dateTo'];
    }

    queryParameters['dateTo'] = this.transformParameter(
      queryParameters['dateTo'],
    );

    if (typeof parameters['closed'] !== 'undefined') {
      queryParameters['closed'] = parameters['closed'];
    }

    queryParameters['closed'] = this.transformParameter(
      queryParameters['closed'],
    );

    if (typeof parameters['teamId'] !== 'undefined') {
      queryParameters['teamId'] = parameters['teamId'];
    }

    queryParameters['teamId'] = this.transformParameter(
      queryParameters['teamId'],
    );

    if (typeof parameters['ids'] !== 'undefined') {
      queryParameters['ids'] = parameters['ids'];
    }

    queryParameters['ids'] = this.transformParameter(queryParameters['ids']);

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getLatestTeamAppSpaceResultsTable
   */
  getLatestTeamAppSpaceResultsTable(
    appSpace: string,
    parameters: {
      ownerPpo?: string;
    } = {},
  ): Promise<{
    _id: string;

    competitionId: string;

    appSpace: string;

    name: string;

    rounds?: Array<{
      _id: string;

      name: string;

      dateFrom: string;

      dateTo: string;
    }>;

    dateFrom: string;

    dateTo: string;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };
  }> {
    let path = '/team-competitions/{appSpace}/latest-resultsTable';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    if (typeof parameters['ownerPpo'] !== 'undefined') {
      queryParameters['ownerPPO'] = parameters['ownerPpo'];
    }

    queryParameters['ownerPPO'] = this.transformParameter(
      queryParameters['ownerPPO'],
    );

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getClubCompetitions
   */
  getClubCompetitions(
    appSpace: string,
    parameters: {
      ownerPpo?: string;
    } = {},
  ): Promise<{
    competitions: Array<{
      _id: string;

      __issfId?: number;

      competitionGroupId: string;

      appSpace: string;

      name: string;

      parts: Array<{
        _id: string;

        name: string;

        rules: {
          sport_sector: string;

          gender: string;

          category?: string;
        };

        teams: Array<{
          _id: string;

          name: string;

          appSpace: string;
        }>;
      }>;

      season: {
        _id: string;

        name: string;
      };
    }>;
  }> {
    let path = '/club/{appSpace}/competitions';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    if (typeof parameters['ownerPpo'] !== 'undefined') {
      queryParameters['ownerPPO'] = parameters['ownerPpo'];
    }

    queryParameters['ownerPPO'] = this.transformParameter(
      queryParameters['ownerPPO'],
    );

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getUnionSeasons
   */
  getUnionSeasons(
    appSpace: string,
    parameters: {} = {},
  ): Promise<{
    seasons: Array<{
      _id: string;

      name: string;

      sport: string;

      appSpace: string;

      dateFrom: string;

      dateTo: string;
    }>;
  }> {
    let path = '/union/{appSpace}/seasons';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getPlayerSummaryStatistics
   */
  getPlayerSummaryStatistics(
    sportnetId: string,
    parameters: {} = {},
  ): Promise<{
    items: Array<{
      stats: {};

      seasonName: string;
    }>;
  }> {
    let path = '/player/{sportnetId}/statistics';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    path = path.replace('{sportnetId}', sportnetId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getHobbySportGrounds
   */
  getHobbySportGrounds(
    appSpace: string,
    parameters: {
      q?: string;
    } = {},
  ): Promise<{
    items?: Array<{
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    }>;
  }> {
    let path = '/hobby/{appSpace}/sportgrounds';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    if (typeof parameters['q'] !== 'undefined') {
      queryParameters['q'] = parameters['q'];
    }

    queryParameters['q'] = this.transformParameter(queryParameters['q']);

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#createHobbySportGround
   */
  createHobbySportGround(
    appSpace: string,
    parameters: {} = {},
    body: {
      sport: string;

      street: string;

      number?: string;

      zip: string;

      city: string;

      country: string;

      geo: {
        lat: number;

        lng: number;
      };
    },
  ): Promise<{
    items?: Array<{
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    }>;
  }> {
    let path = '/hobby/{appSpace}/sportgrounds';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getHobbySportGroundById
   */
  getHobbySportGroundById(
    appSpace: string,
    sportGroundId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    name: string;

    sportGroundType: string;

    additionalData?: {};
  }> {
    let path = '/hobby/{appSpace}/sportgrounds/{sportGroundId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{sportGroundId}', sportGroundId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#createHobbyMatch
   */
  createHobbyMatch(
    appSpace: string,
    parameters: {} = {},
    body: {
      startDate: string;

      sportGround: {
        _id: string;
      };

      competitionId: string;

      partId: string;

      rules?: {
        gender?: string;

        bornDateFrom?: string;

        bornDateTo?: string;
      };
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;

    startDate: string;

    sportGround: {
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    };

    competition: {
      _id: string;

      name: string;

      competitionGroupId: string;
    };

    competitionPart: {
      _id: string;

      name: string;
    };

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    round?: {
      _id?: string;

      name: string;

      dateFrom?: string;

      dateTo?: string;
    };

    nominations: Array<{
      teamId?: string;

      athletes: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;

      crew?: Array<{
        sportnetUser: {
          _id: string | null;

          name: string | null;
        };

        position: string;
      }>;

      closed?: boolean;
    }>;

    protocol?: {
      events?: Array<{}>;
    };

    rules?: {
      gender?: string;

      sport_sector?: string;

      discipline?: string;
    };

    closed?: boolean;

    contumation?: {
      isContumated: boolean;

      advantage: null | string;

      keepScore: boolean;
    };

    score?: Array<number>;

    livestream?: string;

    ticketsUrl?: string;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    settings: {
      players: {
        field: {
          min: number;

          max: number;
        };

        substitutes: {
          max: number;
        };
      };

      contumation: {
        score: number;
      };

      reverseTime: boolean;

      overlapTime: boolean;

      phases: {};
    };

    liveState?: {
      phase: string;

      seconds: number;

      ongoing: boolean;

      toggleDate: string;
    };

    drawId?: number;

    timer?: {};

    managers?: Array<{
      user: {
        _id: string;

        name: string;
      };

      type: {
        label: string;

        value: string;
      };

      grant?: boolean;
    }>;
  }> {
    let path = '/hobby/{appSpace}/matches';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getHobbyMatchById
   */
  getHobbyMatchById(
    appSpace: string,
    matchId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    appSpace: string;

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;

    startDate: string;

    sportGround: {
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    };

    competition: {
      _id: string;

      name: string;

      competitionGroupId: string;
    };

    competitionPart: {
      _id: string;

      name: string;
    };

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    round?: {
      _id?: string;

      name: string;

      dateFrom?: string;

      dateTo?: string;
    };

    nominations: Array<{
      teamId?: string;

      athletes: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;

      crew?: Array<{
        sportnetUser: {
          _id: string | null;

          name: string | null;
        };

        position: string;
      }>;

      closed?: boolean;
    }>;

    protocol?: {
      events?: Array<{}>;
    };

    rules?: {
      gender?: string;

      sport_sector?: string;

      discipline?: string;
    };

    closed?: boolean;

    contumation?: {
      isContumated: boolean;

      advantage: null | string;

      keepScore: boolean;
    };

    score?: Array<number>;

    livestream?: string;

    ticketsUrl?: string;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    settings: {
      players: {
        field: {
          min: number;

          max: number;
        };

        substitutes: {
          max: number;
        };
      };

      contumation: {
        score: number;
      };

      reverseTime: boolean;

      overlapTime: boolean;

      phases: {};
    };

    liveState?: {
      phase: string;

      seconds: number;

      ongoing: boolean;

      toggleDate: string;
    };

    drawId?: number;

    timer?: {};

    managers?: Array<{
      user: {
        _id: string;

        name: string;
      };

      type: {
        label: string;

        value: string;
      };

      grant?: boolean;
    }>;
  }> {
    let path = '/hobby/{appSpace}/matches/{matchId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#updateHobbyMatch
   */
  updateHobbyMatch(
    appSpace: string,
    matchId: string,
    parameters: {} = {},
    body: {
      startDate: string;

      sportGround?: {
        _id: string;
      };

      competitionId: string;

      partId: string;

      protocol?: {};

      rules?: {
        sport_sector?: string;

        gender?: string;

        bornDateFrom?: string;

        bornDateTo?: string;
      };

      settings?: {
        players: {
          field: {
            max: number;
          };

          substitutes: {
            max?: number;
          };
        };
      };

      closed?: boolean;
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;

    startDate: string;

    sportGround: {
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    };

    competition: {
      _id: string;

      name: string;

      competitionGroupId: string;
    };

    competitionPart: {
      _id: string;

      name: string;
    };

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    round?: {
      _id?: string;

      name: string;

      dateFrom?: string;

      dateTo?: string;
    };

    nominations: Array<{
      teamId?: string;

      athletes: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;

      crew?: Array<{
        sportnetUser: {
          _id: string | null;

          name: string | null;
        };

        position: string;
      }>;

      closed?: boolean;
    }>;

    protocol?: {
      events?: Array<{}>;
    };

    rules?: {
      gender?: string;

      sport_sector?: string;

      discipline?: string;
    };

    closed?: boolean;

    contumation?: {
      isContumated: boolean;

      advantage: null | string;

      keepScore: boolean;
    };

    score?: Array<number>;

    livestream?: string;

    ticketsUrl?: string;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    settings: {
      players: {
        field: {
          min: number;

          max: number;
        };

        substitutes: {
          max: number;
        };
      };

      contumation: {
        score: number;
      };

      reverseTime: boolean;

      overlapTime: boolean;

      phases: {};
    };

    liveState?: {
      phase: string;

      seconds: number;

      ongoing: boolean;

      toggleDate: string;
    };

    drawId?: number;

    timer?: {};

    managers?: Array<{
      user: {
        _id: string;

        name: string;
      };

      type: {
        label: string;

        value: string;
      };

      grant?: boolean;
    }>;
  }> {
    let path = '/hobby/{appSpace}/matches/{matchId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#deleteHobbyMatch
   */
  deleteHobbyMatch(
    appSpace: string,
    matchId: string,
    parameters: {} = {},
  ): Promise<{
    message: string;
  }> {
    let path = '/hobby/{appSpace}/matches/{matchId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'DELETE',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#copyHobbyMatch
   */
  copyHobbyMatch(
    appSpace: string,
    matchId: string,
    parameters: {} = {},
    body: {
      startDate: string;

      sportGround?: {
        _id: string;
      };

      competitionId: string;

      partId: string;

      protocol?: {};

      rules?: {
        sport_sector?: string;

        gender?: string;

        bornDateFrom?: string;

        bornDateTo?: string;
      };

      settings?: {
        players: {
          field: {
            max: number;
          };

          substitutes: {
            max?: number;
          };
        };
      };

      closed?: boolean;
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;

    startDate: string;

    sportGround: {
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    };

    competition: {
      _id: string;

      name: string;

      competitionGroupId: string;
    };

    competitionPart: {
      _id: string;

      name: string;
    };

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    round?: {
      _id?: string;

      name: string;

      dateFrom?: string;

      dateTo?: string;
    };

    nominations: Array<{
      teamId?: string;

      athletes: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;

      crew?: Array<{
        sportnetUser: {
          _id: string | null;

          name: string | null;
        };

        position: string;
      }>;

      closed?: boolean;
    }>;

    protocol?: {
      events?: Array<{}>;
    };

    rules?: {
      gender?: string;

      sport_sector?: string;

      discipline?: string;
    };

    closed?: boolean;

    contumation?: {
      isContumated: boolean;

      advantage: null | string;

      keepScore: boolean;
    };

    score?: Array<number>;

    livestream?: string;

    ticketsUrl?: string;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    settings: {
      players: {
        field: {
          min: number;

          max: number;
        };

        substitutes: {
          max: number;
        };
      };

      contumation: {
        score: number;
      };

      reverseTime: boolean;

      overlapTime: boolean;

      phases: {};
    };

    liveState?: {
      phase: string;

      seconds: number;

      ongoing: boolean;

      toggleDate: string;
    };

    drawId?: number;

    timer?: {};

    managers?: Array<{
      user: {
        _id: string;

        name: string;
      };

      type: {
        label: string;

        value: string;
      };

      grant?: boolean;
    }>;
  }> {
    let path = '/hobby/{appSpace}/matches/{matchId}/copy';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getHobbyMatchNomination
   */
  getHobbyMatchNomination(
    appSpace: string,
    matchId: string,
    teamId: string,
    parameters: {} = {},
  ): Promise<{
    teamId?: string;

    athletes: Array<{
      sportnetUser: {
        _id: string;

        name: string;
      };

      additionalData?: {};
    }>;

    crew?: Array<{
      sportnetUser: {
        _id: string | null;

        name: string | null;
      };

      position: string;
    }>;

    closed?: boolean;
  }> {
    let path = '/hobby/{appSpace}/matches/{matchId}/nominations/{teamId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#updateHobbyMatchNomination
   */
  updateHobbyMatchNomination(
    appSpace: string,
    matchId: string,
    teamId: string,
    parameters: {} = {},
    body: {
      teamId?: string;

      athletes: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;

      crew?: Array<{
        sportnetUser: {
          _id: string | null;

          name: string | null;
        };

        position: string;
      }>;

      closed?: boolean;

      name?: string;
    },
  ): Promise<{}> {
    let path = '/hobby/{appSpace}/matches/{matchId}/nominations/{teamId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#hobbyCreateCompetitionPart
   */
  hobbyCreateCompetitionPart(
    appSpace: string,
    competitionId: string,
    parameters: {} = {},
    body: {
      name: string;

      rules?: {
        sport_sector?: string;

        gender?: string;

        bornDateFrom?: string;

        bornDateTo?: string;
      };

      dateFrom: string;

      dateTo: string;
    },
  ): Promise<{
    _id: string;

    name: string;

    rules?: {
      sport_sector: string;

      gender?: string;

      bornDateFrom?: string;

      bornDateTo?: string;
    };

    dateFrom: string;

    dateTo: string;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    matches_count?: number;
  }> {
    let path = '/hobby/{appSpace}/competitions/{competitionId}/parts';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#hobbyGetCompetitionPart
   */
  hobbyGetCompetitionPart(
    appSpace: string,
    competitionId: string,
    partId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    name: string;

    rules?: {
      sport_sector: string;

      gender?: string;

      bornDateFrom?: string;

      bornDateTo?: string;
    };

    dateFrom: string;

    dateTo: string;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    matches_count?: number;
  }> {
    let path = '/hobby/{appSpace}/competitions/{competitionId}/parts/{partId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#hobbyUpdateCompetitionPart
   */
  hobbyUpdateCompetitionPart(
    appSpace: string,
    competitionId: string,
    partId: string,
    parameters: {} = {},
    body: {
      name?: string;

      rules?: {
        sport_sector: string;

        gender?: string;

        bornDateFrom?: string;

        bornDateTo?: string;
      };

      dateFrom?: string;

      dateTo?: string;
    },
  ): Promise<{
    _id: string;

    name: string;

    rules?: {
      sport_sector: string;

      gender?: string;

      bornDateFrom?: string;

      bornDateTo?: string;
    };

    dateFrom: string;

    dateTo: string;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    matches_count?: number;
  }> {
    let path = '/hobby/{appSpace}/competitions/{competitionId}/parts/{partId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#hobbyDeleteCompetitionPart
   */
  hobbyDeleteCompetitionPart(
    appSpace: string,
    competitionId: string,
    partId: string,
    parameters: {} = {},
  ): Promise<{
    message: string;
  }> {
    let path = '/hobby/{appSpace}/competitions/{competitionId}/parts/{partId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    return this.request(
      'DELETE',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#hobbyGetCompetitionPartCurrentResultTable
   */
  hobbyGetCompetitionPartCurrentResultTable(
    appSpace: string,
    competitionId: string,
    partId: string,
    parameters: {} = {},
  ): Promise<{
    results: Array<{
      team: {
        _id: string;

        name: string;

        displayName: string;

        resignation?: boolean;
      };

      stats: {
        matches: {
          played: number;

          won: number;

          draw: number;

          lost: number;
        };

        goals: {
          given: number;

          received: number;
        };

        points: number;
      };

      homeStats?: {
        matches: {
          played: number;

          won: number;

          draw: number;

          lost: number;
        };

        goals: {
          given: number;

          received: number;
        };

        points: number;
      };

      awayStats?: {
        matches: {
          played: number;

          won: number;

          draw: number;

          lost: number;
        };

        goals: {
          given: number;

          received: number;
        };

        points: number;
      };

      matches?: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;
        };

        result: 'W' | 'L' | 'D';

        homeaway: 'home' | 'away';

        matchId: string;

        score: string;
      }>;

      homeMatches?: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;
        };

        result: 'W' | 'L' | 'D';

        homeaway: 'home' | 'away';

        matchId: string;

        score: string;
      }>;

      awayMatches?: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;
        };

        result: 'W' | 'L' | 'D';

        homeaway: 'home' | 'away';

        matchId: string;

        score: string;
      }>;
    }>;

    players?: Array<{
      _id: string;

      teamId: string;

      name: string;

      stats: {
        match_starts?: number;

        match_appearances?: number;

        goals?: number;

        assists?: number;

        yellow_cards?: number;

        red_cards?: number;

        substitutions?: number;

        own_goals?: number;
      };
    }>;
  }> {
    let path =
      '/hobby/{appSpace}/competitions/{competitionId}/parts/{partId}/results';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#hobbyCreateTeam
   */
  hobbyCreateTeam(
    appSpace: string,
    competitionId: string,
    partId: string,
    parameters: {} = {},
    body: {
      _id?: string;

      appSpace?: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    logo?: {
      media_url: string;

      public_url: string;
    };

    smarttags?: Array<{
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    }>;

    name: string;

    displayName: string;

    gender?: string;

    sport_sector: string;

    athletes?: Array<{
      sportnetUser: {
        _id: string;

        name: string;
      };

      additionalData?: {};
    }>;
  }> {
    let path =
      '/hobby/{appSpace}/competitions/{competitionId}/parts/{partId}/teams';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#hobbyRemoveCompetitionPartSignedUpTeam
   */
  hobbyRemoveCompetitionPartSignedUpTeam(
    appSpace: string,
    competitionId: string,
    partId: string,
    teamId: string,
    parameters: {} = {},
  ): Promise<{
    message?: string;
  }> {
    let path =
      '/hobby/{appSpace}/competitions/{competitionId}/parts/{partId}/teams/{teamId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'DELETE',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#createHobbyTournamentMatch
   */
  createHobbyTournamentMatch(
    appSpace: string,
    parameters: {} = {},
    body: {
      startDate: string;

      sportGround: {
        _id: string;
      };

      competitionId: string;

      partId: string;

      rules?: {
        gender?: string;

        bornDateFrom?: string;

        bornDateTo?: string;
      };

      teams?: Array<{
        _id: string;
      }>;
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;

    startDate: string;

    sportGround: {
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    };

    competition: {
      _id: string;

      name: string;

      competitionGroupId: string;
    };

    competitionPart: {
      _id: string;

      name: string;
    };

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    round?: {
      _id?: string;

      name: string;

      dateFrom?: string;

      dateTo?: string;
    };

    nominations: Array<{
      teamId?: string;

      athletes: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;

      crew?: Array<{
        sportnetUser: {
          _id: string | null;

          name: string | null;
        };

        position: string;
      }>;

      closed?: boolean;
    }>;

    protocol?: {
      events?: Array<{}>;
    };

    rules?: {
      gender?: string;

      sport_sector?: string;

      discipline?: string;
    };

    closed?: boolean;

    contumation?: {
      isContumated: boolean;

      advantage: null | string;

      keepScore: boolean;
    };

    score?: Array<number>;

    livestream?: string;

    ticketsUrl?: string;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    settings: {
      players: {
        field: {
          min: number;

          max: number;
        };

        substitutes: {
          max: number;
        };
      };

      contumation: {
        score: number;
      };

      reverseTime: boolean;

      overlapTime: boolean;

      phases: {};
    };

    liveState?: {
      phase: string;

      seconds: number;

      ongoing: boolean;

      toggleDate: string;
    };

    drawId?: number;

    timer?: {};

    managers?: Array<{
      user: {
        _id: string;

        name: string;
      };

      type: {
        label: string;

        value: string;
      };

      grant?: boolean;
    }>;
  }> {
    let path =
      '/hobby/{appSpace}/competitions/{competitionId}/parts/{partId}/matches';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#updateHobbyTournamentMatch
   */
  updateHobbyTournamentMatch(
    appSpace: string,
    matchId: string,
    parameters: {} = {},
    body: {
      startDate: string;

      sportGround?: {
        _id: string;
      };

      competitionId: string;

      partId: string;

      protocol?: {};

      rules?: {
        sport_sector?: string;

        gender?: string;

        bornDateFrom?: string;

        bornDateTo?: string;
      };

      settings?: {
        players: {
          field: {
            max: number;
          };

          substitutes: {
            max?: number;
          };
        };
      };

      closed?: boolean;

      teams?: Array<{
        _id: string;
      }>;
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    smarttags?: {
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    };

    smarttagsByAppSpace?: Array<{
      appSpace: string;

      smarttags: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };
    }>;

    teams: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;

    startDate: string;

    sportGround: {
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    };

    competition: {
      _id: string;

      name: string;

      competitionGroupId: string;
    };

    competitionPart: {
      _id: string;

      name: string;
    };

    season: {
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    };

    round?: {
      _id?: string;

      name: string;

      dateFrom?: string;

      dateTo?: string;
    };

    nominations: Array<{
      teamId?: string;

      athletes: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;

      crew?: Array<{
        sportnetUser: {
          _id: string | null;

          name: string | null;
        };

        position: string;
      }>;

      closed?: boolean;
    }>;

    protocol?: {
      events?: Array<{}>;
    };

    rules?: {
      gender?: string;

      sport_sector?: string;

      discipline?: string;
    };

    closed?: boolean;

    contumation?: {
      isContumated: boolean;

      advantage: null | string;

      keepScore: boolean;
    };

    score?: Array<number>;

    livestream?: string;

    ticketsUrl?: string;

    resultsTable?: {
      results: Array<{
        team: {
          _id: string;

          name: string;

          displayName: string;

          resignation?: boolean;
        };

        stats: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        homeStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        awayStats?: {
          matches: {
            played: number;

            won: number;

            draw: number;

            lost: number;
          };

          goals: {
            given: number;

            received: number;
          };

          points: number;
        };

        matches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        homeMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;

        awayMatches?: Array<{
          team: {
            _id: string;

            name: string;

            displayName: string;
          };

          result: 'W' | 'L' | 'D';

          homeaway: 'home' | 'away';

          matchId: string;

          score: string;
        }>;
      }>;

      players?: Array<{
        _id: string;

        teamId: string;

        name: string;

        stats: {
          match_starts?: number;

          match_appearances?: number;

          goals?: number;

          assists?: number;

          yellow_cards?: number;

          red_cards?: number;

          substitutions?: number;

          own_goals?: number;
        };
      }>;
    };

    settings: {
      players: {
        field: {
          min: number;

          max: number;
        };

        substitutes: {
          max: number;
        };
      };

      contumation: {
        score: number;
      };

      reverseTime: boolean;

      overlapTime: boolean;

      phases: {};
    };

    liveState?: {
      phase: string;

      seconds: number;

      ongoing: boolean;

      toggleDate: string;
    };

    drawId?: number;

    timer?: {};

    managers?: Array<{
      user: {
        _id: string;

        name: string;
      };

      type: {
        label: string;

        value: string;
      };

      grant?: boolean;
    }>;
  }> {
    let path =
      '/hobby/{appSpace}/competitions/{competitionId}/parts/{partId}/matches/{matchId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#DSGGetSeasons
   */
  DSGGetSeasons(
    parameters: {} = {},
  ): Promise<{
    seasons: Array<{
      _id: string;

      appSpace: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    }>;
  }> {
    let path = '/dajmespolugol/seasons';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#DSGCreateSeason
   */
  DSGCreateSeason(
    parameters: {} = {},
    body: {
      _id?: string;

      appSpace?: string;

      name: string;

      dateFrom: string;

      dateTo: string;

      sport: string;
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    name: string;

    dateFrom: string;

    dateTo: string;

    sport: string;
  }> {
    let path = '/dajmespolugol/seasons';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#DSGGetCompetitions
   */
  DSGGetCompetitions(
    parameters: {
      limit?: number;
      offset?: number;
      seasonIds?: Array<string>;
    } = {},
  ): Promise<{
    competitions: Array<{
      _id: string;

      competitionGroupId: string;

      homepageSectionIdOrUniqId?: string;

      appSpace: string;

      name: string;

      season: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      sport: string;

      parts?: Array<{
        _id: string;

        name: string;

        rounds?: Array<{
          _id: string;

          name: string;

          dateFrom: string;

          dateTo: string;
        }>;

        rules?: {};

        settings?: {};

        signup?: boolean;

        resultsTable?: {
          results: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;

              resignation?: boolean;
            };

            stats: {
              matches: {
                played: number;

                won: number;

                draw: number;

                lost: number;
              };

              goals: {
                given: number;

                received: number;
              };

              points: number;
            };

            homeStats?: {
              matches: {
                played: number;

                won: number;

                draw: number;

                lost: number;
              };

              goals: {
                given: number;

                received: number;
              };

              points: number;
            };

            awayStats?: {
              matches: {
                played: number;

                won: number;

                draw: number;

                lost: number;
              };

              goals: {
                given: number;

                received: number;
              };

              points: number;
            };

            matches?: Array<{
              team: {
                _id: string;

                name: string;

                displayName: string;
              };

              result: 'W' | 'L' | 'D';

              homeaway: 'home' | 'away';

              matchId: string;

              score: string;
            }>;

            homeMatches?: Array<{
              team: {
                _id: string;

                name: string;

                displayName: string;
              };

              result: 'W' | 'L' | 'D';

              homeaway: 'home' | 'away';

              matchId: string;

              score: string;
            }>;

            awayMatches?: Array<{
              team: {
                _id: string;

                name: string;

                displayName: string;
              };

              result: 'W' | 'L' | 'D';

              homeaway: 'home' | 'away';

              matchId: string;

              score: string;
            }>;
          }>;

          players?: Array<{
            _id: string;

            teamId: string;

            name: string;

            stats: {
              match_starts?: number;

              match_appearances?: number;

              goals?: number;

              assists?: number;

              yellow_cards?: number;

              red_cards?: number;

              substitutions?: number;

              own_goals?: number;
            };
          }>;
        };

        matches_count?: number;

        dateFrom: string;

        dateTo: string;
      }>;

      signup?: boolean;

      publication?: {};

      smarttags?: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };

      smarttagsByAppSpace?: Array<{
        appSpace: string;

        smarttags: {
          key: string | number;

          values: Array<{
            key: string | number;

            title?: string | null;
          }>;
        };
      }>;

      teams?: Array<{
        _id: string;

        name: string;

        appSpace: string;
      }>;
    }>;
  }> {
    let path = '/dajmespolugol/competitions';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    queryParameters['limit'] = 100;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    if (typeof parameters['seasonIds'] !== 'undefined') {
      queryParameters['season_ids'] = parameters['seasonIds'];
    }

    queryParameters['season_ids'] = this.transformParameter(
      queryParameters['season_ids'],
    );

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#DSGCreateCompetition
   */
  DSGCreateCompetition(
    parameters: {} = {},
    body: {
      competitionGroupId?: string;

      homepageSectionIdOrUniqId?: string;

      name: string;

      season: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      sport: string;

      signup?: boolean;

      publication?: {};

      smarttags?: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };

      smarttagsByAppSpace?: Array<{
        appSpace: string;

        smarttags: {
          key: string | number;

          values: Array<{
            key: string | number;

            title?: string | null;
          }>;
        };
      }>;

      teams?: Array<{
        _id: string;

        name: string;

        appSpace: string;
      }>;
    },
  ): Promise<{
    createdCompetition: {
      _id: string;

      competitionGroupId: string;

      homepageSectionIdOrUniqId?: string;

      appSpace: string;

      name: string;

      season: {
        _id: string;

        appSpace: string;

        name: string;

        dateFrom: string;

        dateTo: string;

        sport: string;
      };

      sport: string;

      parts?: Array<{
        _id: string;

        name: string;

        rounds?: Array<{
          _id: string;

          name: string;

          dateFrom: string;

          dateTo: string;
        }>;

        rules?: {};

        settings?: {};

        signup?: boolean;

        resultsTable?: {
          results: Array<{
            team: {
              _id: string;

              name: string;

              displayName: string;

              resignation?: boolean;
            };

            stats: {
              matches: {
                played: number;

                won: number;

                draw: number;

                lost: number;
              };

              goals: {
                given: number;

                received: number;
              };

              points: number;
            };

            homeStats?: {
              matches: {
                played: number;

                won: number;

                draw: number;

                lost: number;
              };

              goals: {
                given: number;

                received: number;
              };

              points: number;
            };

            awayStats?: {
              matches: {
                played: number;

                won: number;

                draw: number;

                lost: number;
              };

              goals: {
                given: number;

                received: number;
              };

              points: number;
            };

            matches?: Array<{
              team: {
                _id: string;

                name: string;

                displayName: string;
              };

              result: 'W' | 'L' | 'D';

              homeaway: 'home' | 'away';

              matchId: string;

              score: string;
            }>;

            homeMatches?: Array<{
              team: {
                _id: string;

                name: string;

                displayName: string;
              };

              result: 'W' | 'L' | 'D';

              homeaway: 'home' | 'away';

              matchId: string;

              score: string;
            }>;

            awayMatches?: Array<{
              team: {
                _id: string;

                name: string;

                displayName: string;
              };

              result: 'W' | 'L' | 'D';

              homeaway: 'home' | 'away';

              matchId: string;

              score: string;
            }>;
          }>;

          players?: Array<{
            _id: string;

            teamId: string;

            name: string;

            stats: {
              match_starts?: number;

              match_appearances?: number;

              goals?: number;

              assists?: number;

              yellow_cards?: number;

              red_cards?: number;

              substitutions?: number;

              own_goals?: number;
            };
          }>;
        };

        matches_count?: number;

        dateFrom: string;

        dateTo: string;
      }>;

      signup?: boolean;

      publication?: {};

      smarttags?: {
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      };

      smarttagsByAppSpace?: Array<{
        appSpace: string;

        smarttags: {
          key: string | number;

          values: Array<{
            key: string | number;

            title?: string | null;
          }>;
        };
      }>;

      teams?: Array<{
        _id: string;

        name: string;

        appSpace: string;
      }>;
    };

    createdPart: {
      _id?: string;

      name?: string;

      rules?: {};

      settings?: {};
    };
  }> {
    let path = '/dajmespolugol/competitions';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getPublicDSGMatches
   */
  getPublicDSGMatches(
    parameters: {
      limit?: number;
      offset?: number;
      matchIds?: Array<string>;
    } = {},
  ): Promise<{
    total: number;

    limit: number;

    offset: number;

    items: Array<{
      _id?: string;

      startDate?: string;

      sportGround?: {
        _id?: string;

        name?: string;

        geo?: {
          type?: string;

          coordinates?: Array<number>;
        };
      };
    }>;
  }> {
    let path = '/dajmespolugol/matches';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    queryParameters['limit'] = 100;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    if (typeof parameters['matchIds'] !== 'undefined') {
      queryParameters['matchIds'] = parameters['matchIds'];
    }

    queryParameters['matchIds'] = this.transformParameter(
      queryParameters['matchIds'],
    );

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#DSGGetTeamsAthletesCount
   */
  DSGGetTeamsAthletesCount(
    parameters: {
      seasonId?: string;
    } = {},
  ): Promise<{
    items: Array<{
      _id: string;

      appSpace: string;

      name: string;

      athletesCount: number;
    }>;
  }> {
    let path = '/dajmespolugol/teams-athletes-count';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    if (typeof parameters['seasonId'] !== 'undefined') {
      queryParameters['seasonId'] = parameters['seasonId'];
    }

    queryParameters['seasonId'] = this.transformParameter(
      queryParameters['seasonId'],
    );

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getDSGMatches
   */
  getDSGMatches(
    appSpace: string,
    parameters: {
      limit?: number;
      offset?: number;
      matchIds?: Array<string>;
    } = {},
  ): Promise<{
    total: number;

    limit: number;

    offset: number;

    items: Array<{
      _id?: string;

      startDate?: string;

      sportGround?: {
        _id?: string;

        name?: string;

        geo?: {
          type?: string;

          coordinates?: Array<number>;
        };
      };
    }>;
  }> {
    let path = '/dajmespolugol/{appSpace}/matches';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    queryParameters['limit'] = 100;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    if (typeof parameters['matchIds'] !== 'undefined') {
      queryParameters['matchIds'] = parameters['matchIds'];
    }

    queryParameters['matchIds'] = this.transformParameter(
      queryParameters['matchIds'],
    );

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#createDSGMatch
   */
  createDSGMatch(
    appSpace: string,
    parameters: {} = {},
    body: {
      teamId: string;

      startDate: string;

      sportGround: {
        _id: string;
      };

      competitionId: string;

      partId: string;
    },
  ): Promise<{
    _id: string;

    startDate: string;

    season: {
      _id: string;

      name: string;
    };

    sportGround: {
      _id?: string;

      name?: string;

      geo?: {
        type?: string;

        coordinates?: Array<number>;
      };
    };
  }> {
    let path = '/dajmespolugol/{appSpace}/matches';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getDSGPlayerMatches
   */
  getDSGPlayerMatches(
    appSpace: string,
    sportnetId: string,
    parameters: {
      limit?: number;
      offset?: number;
    } = {},
  ): Promise<{
    total: number;

    limit: number;

    offset: number;

    items: Array<{
      _id?: string;

      startDate?: string;

      sportGround?: {
        _id?: string;

        name?: string;

        geo?: {
          type?: string;

          coordinates?: Array<number>;
        };
      };
    }>;
  }> {
    let path = '/dajmespolugol/{appSpace}/player-matches/{sportnetId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers.append('Accept', 'application/json');

    queryParameters['limit'] = 100;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{sportnetId}', sportnetId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getDSGMatch
   */
  getDSGMatch(
    appSpace: string,
    matchId: string,
    parameters: {} = {},
  ): Promise<{
    _id?: string;

    startDate?: string;

    competitionId?: string;

    partId?: string;

    teams?: Array<{
      _id: string;
    }>;

    sportGround?: {
      _id?: string;

      name?: string;

      geo?: {
        type?: string;

        coordinates?: Array<number>;
      };
    };
  }> {
    let path = '/dajmespolugol/{appSpace}/matches/{matchId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#updateDSGMatch
   */
  updateDSGMatch(
    appSpace: string,
    matchId: string,
    parameters: {} = {},
    body: {
      startDate?: string;

      sportGround?: {
        _id: string;
      };
    },
  ): Promise<{
    _id?: string;

    startDate?: string;

    sportGround?: {
      _id?: string;

      name?: string;

      geo?: {
        type?: string;

        coordinates?: Array<number>;
      };
    };
  }> {
    let path = '/dajmespolugol/{appSpace}/matches/{matchId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#deleteDSGMatch
   */
  deleteDSGMatch(
    appSpace: string,
    matchId: string,
    parameters: {} = {},
  ): Promise<{
    message?: string;
  }> {
    let path = '/dajmespolugol/{appSpace}/matches/{matchId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    return this.request(
      'DELETE',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getDSGMatchNomination
   */
  getDSGMatchNomination(
    appSpace: string,
    matchId: string,
    teamId: string,
    parameters: {} = {},
  ): Promise<{
    teamId?: string;

    athletes: Array<{
      sportnetUser: {
        _id: string;

        name: string;
      };

      additionalData?: {};
    }>;

    crew?: Array<{
      sportnetUser: {
        _id: string | null;

        name: string | null;
      };

      position: string;
    }>;

    closed?: boolean;
  }> {
    let path =
      '/dajmespolugol/{appSpace}/matches/{matchId}/nominations/{teamId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#updateDSGMatchNomination
   */
  updateDSGMatchNomination(
    appSpace: string,
    matchId: string,
    teamId: string,
    parameters: {} = {},
    body: {
      teamId?: string;

      athletes: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;

      crew?: Array<{
        sportnetUser: {
          _id: string | null;

          name: string | null;
        };

        position: string;
      }>;

      closed?: boolean;
    },
  ): Promise<{}> {
    let path =
      '/dajmespolugol/{appSpace}/matches/{matchId}/nominations/{teamId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{matchId}', matchId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#getDSGSportGrounds
   */
  getDSGSportGrounds(
    appSpace: string,
    parameters: {
      q?: string;
    } = {},
  ): Promise<{
    items?: Array<{
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    }>;
  }> {
    let path = '/dajmespolugol/{appSpace}/sportgrounds';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    if (typeof parameters['q'] !== 'undefined') {
      queryParameters['q'] = parameters['q'];
    }

    queryParameters['q'] = this.transformParameter(queryParameters['q']);

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#createDSGSportGround
   */
  createDSGSportGround(
    appSpace: string,
    parameters: {} = {},
    body: {
      sport: string;

      street: string;

      number?: string;

      zip: string;

      city: string;

      country: string;

      geo: {
        lat: number;

        lng: number;
      };
    },
  ): Promise<{
    items?: Array<{
      _id: string;

      name: string;

      sportGroundType: string;

      additionalData?: {};
    }>;
  }> {
    let path = '/dajmespolugol/{appSpace}/sportgrounds';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#DSGGetSportGround
   */
  DSGGetSportGround(
    appSpace: string,
    sportgroundId: string,
    parameters: {} = {},
  ): Promise<{
    sport: string;

    street: string;

    number?: string;

    zip: string;

    city: string;

    country: string;

    geo: {
      lat: number;

      lng: number;
    };
  }> {
    let path = '/dajmespolugol/{appSpace}/sportgrounds/{sportgroundId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{sportgroundId}', sportgroundId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#DSGUpdateSportGround
   */
  DSGUpdateSportGround(
    appSpace: string,
    sportgroundId: string,
    parameters: {} = {},
    body: {
      street: string;

      number?: string;

      zip: string;

      city: string;

      country: string;

      geo: {
        lat: number;

        lng: number;
      };
    },
  ): Promise<{
    street: string;

    number?: string;

    zip: string;

    city: string;

    country: string;

    geo: {
      lat: number;

      lng: number;
    };
  }> {
    let path = '/dajmespolugol/{appSpace}/sportgrounds/{sportgroundId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{sportgroundId}', sportgroundId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#DSGGetCompetitionTeams
   */
  DSGGetCompetitionTeams(
    competitionId: string,
    parameters: {} = {},
  ): Promise<{
    teams: Array<{
      _id: string;

      appSpace: string;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        playedMinutes: number;

        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;
  }> {
    let path = '/dajmespolugol/competition-teams/{competitionId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{competitionId}', competitionId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#DSGGetTeams
   */
  DSGGetTeams(
    appSpace: string,
    parameters: {
      limit?: number;
      offset?: number;
      competitionId?: string;
    } = {},
  ): Promise<{
    limit: number;

    offset: number;

    total: number;

    nextOffset?: number;

    teams: Array<{
      _id: string;

      appSpace: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      athletes?: Array<{
        sportnetUser: {
          _id: string;

          name: string;
        };

        additionalData?: {};
      }>;
    }>;
  }> {
    let path = '/dajmespolugol/{appSpace}/teams';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(
      queryParameters['limit'],
    );

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(
      queryParameters['offset'],
    );

    if (typeof parameters['competitionId'] !== 'undefined') {
      queryParameters['competitionId'] = parameters['competitionId'];
    }

    queryParameters['competitionId'] = this.transformParameter(
      queryParameters['competitionId'],
    );

    path = path.replace('{appSpace}', appSpace.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#DSGGetTeam
   */
  DSGGetTeam(
    appSpace: string,
    teamId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    appSpace: string;

    logo?: {
      media_url: string;

      public_url: string;
    };

    smarttags?: Array<{
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    }>;

    name: string;

    displayName: string;

    gender?: string;

    sport_sector: string;

    athletes?: Array<{
      sportnetUser: {
        _id: string;

        name: string;
      };

      additionalData?: {};
    }>;
  }> {
    let path = '/dajmespolugol/{appSpace}/teams/{teamId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#DSGUpdateTeam
   */
  DSGUpdateTeam(
    appSpace: string,
    teamId: string,
    parameters: {} = {},
    body: {
      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;

      name?: string;

      displayName?: string;

      logo?: {
        media_url: string;

        public_url: string;
      };
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    logo?: {
      media_url: string;

      public_url: string;
    };

    smarttags?: Array<{
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    }>;

    name: string;

    displayName: string;

    gender?: string;

    sport_sector: string;

    athletes?: Array<{
      sportnetUser: {
        _id: string;

        name: string;
      };

      additionalData?: {};
    }>;
  }> {
    let path = '/dajmespolugol/{appSpace}/teams/{teamId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'PUT',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#DSGDeleteTeam
   */
  DSGDeleteTeam(
    appSpace: string,
    teamId: string,
    parameters: {} = {},
  ): Promise<{}> {
    let path = '/dajmespolugol/{appSpace}/teams/{teamId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'DELETE',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#DSGCreateTeam
   */
  DSGCreateTeam(
    appSpace: string,
    competitionId: string,
    partId: string,
    parameters: {} = {},
    body: {
      _id?: string;

      appSpace?: string;

      logo?: {
        media_url: string;

        public_url: string;
      };

      name: string;

      displayName: string;

      gender?: string;

      sport_sector: string;

      smarttags?: Array<{
        key: string | number;

        values: Array<{
          key: string | number;

          title?: string | null;
        }>;
      }>;
    },
  ): Promise<{
    _id: string;

    appSpace: string;

    logo?: {
      media_url: string;

      public_url: string;
    };

    smarttags?: Array<{
      key: string | number;

      values: Array<{
        key: string | number;

        title?: string | null;
      }>;
    }>;

    name: string;

    displayName: string;

    gender?: string;

    sport_sector: string;

    athletes?: Array<{
      sportnetUser: {
        _id: string;

        name: string;
      };

      additionalData?: {};
    }>;
  }> {
    let path =
      '/dajmespolugol/{appSpace}/competitions/{competitionId}/parts/{partId}/teams';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#DSGGetCompetitionPartTeamSquad
   */
  DSGGetCompetitionPartTeamSquad(
    appSpace: string,
    competitionId: string,
    partId: string,
    teamId: string,
    parameters: {} = {},
  ): Promise<{
    _id: string;

    name: string;

    type?: string;

    sport_sector: string;

    squad?: {
      athletes?: Array<{
        additionalProperties?: {};

        sportnetUser: {
          _id: string;

          name: string;
        };
      }>;
    };
  }> {
    let path =
      '/dajmespolugol/{appSpace}/competitions/{competitionId}/parts/{partId}/teams/{teamId}/players';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'GET',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#DSGAddPlayerToCompetitionPartTeamSquad
   */
  DSGAddPlayerToCompetitionPartTeamSquad(
    appSpace: string,
    competitionId: string,
    partId: string,
    teamId: string,
    parameters: {} = {},
    body: {
      sportnetId?: string;

      additionalData?: {};
    },
  ): Promise<{
    _id?: string;

    name?: string;

    squad?: Array<{}>;
  }> {
    let path =
      '/dajmespolugol/{appSpace}/competitions/{competitionId}/parts/{partId}/teams/{teamId}/players';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    return this.request(
      'POST',
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
   *
   * @method
   * @name Api#DSGRemovePlayerFromCompetitionPartTeamSquad
   */
  DSGRemovePlayerFromCompetitionPartTeamSquad(
    appSpace: string,
    competitionId: string,
    partId: string,
    teamId: string,
    sportnetId: string,
    parameters: {} = {},
  ): Promise<{
    _id?: string;

    name?: string;

    squad?: Array<{}>;
  }> {
    let path =
      '/dajmespolugol/{appSpace}/competitions/{competitionId}/parts/{partId}/teams/{teamId}/players/{sportnetId}';
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');

    path = path.replace('{appSpace}', appSpace.toString());

    path = path.replace('{competitionId}', competitionId.toString());

    path = path.replace('{partId}', partId.toString());

    path = path.replace('{teamId}', teamId.toString());

    path = path.replace('{sportnetId}', sportnetId.toString());

    return this.request(
      'DELETE',
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
}

export default new Api();
export { Api };
